//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useState, useRef, useReducer, useCallback, useMemo, useEffectEvent } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import styled, { keyframes } from 'styled-components';
import { connect, useDispatch, useStore } from 'react-redux';
import ReactPlayer from 'react-player';

//  -- Components ---------------------
import { Col, Row } from 'antd';
import { Button } from '@mui/material';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ArrowForward, CheckCircle, Done } from '@mui/icons-material';
import Loading from 'components/Loading';
import TextEditor from 'components/TextEditor';
import { HlsVideoPlayer } from 'components/UI';
//  -- Constants ----------------------
import COLOR from 'utils/constants/color';
import { filter, map, find, get, has, debounce, cloneDeep } from "lodash";
//  -- Features -----------------------
import AudioRecorder from "features/AudeoRecorderNew";
//  -- Thunks -------------------------
import { handleCreateSubmission, handleUpdateSubmission, handleAiFeedback, handleAudioTranscript, handleAiAutoGradingSchedule, handleAiStandardFeedback, handleRefreshUserSubmissionInClass, handleGetSumissionById } from 'store/submissions/thunks';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useActiveClassUrl } from 'store/live_logs/selectors';
import { useAllBook } from 'store/books/selectors';
import { useOrgTimezone } from 'store/organizations/selectors';
import { useServertime } from 'store/servertime/selectors';
import { checkAllCorrect, checkAllCorrectMatch, checkIsManualGradable, isBeforTime } from "utils/methods/math";
import { shouldSkipLateDateForDiffStudent, getNumberMask, isEbook } from "utils/lib/ebookHelper";
import {Snackbar , Alert, Modal, Box, Typography, Switch, FormControlLabel} from '@mui/material';
import dayjs from 'utils/dayjsConfig';
import { handleUpdateCanvasGrade, handleCreateCanvaSubmissions } from 'store/canvas/thunks';
import { useSocket } from 'store/chat/selectors';
import { handleUpdateGradeToGoogleClassRoom } from "store/googleClassRoom/thunks";
import ModalMenu from 'components/Modals';
import { handleGradeToSchoology } from 'store/schoology/thunks';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { v4 } from 'uuid';
import { useCollectionAutoSubmission } from 'utils/methods/firebaseAutoSubmission';
import { useCurrentClassTeacher } from 'store/classes/selectors';
import VideoRecorder from './VideoRecorderNew';
import StudentFillInTheBlanks from './forms/assignment/fillInBlanks/studentFillInTheBlanks';
import { StudentMatch } from './forms/assignment';
import BingoStudentContent from 'modules/bingoModule/StudentBingo/BingoStudentContent';
import { isQuestionEmpty } from './forms/assignment/studentMatchMaking/helper';
import { useStoryView } from 'store/main_book_popup/selectors';
import { handleGetArticleByid, handleListStoryById } from 'store/StoryAiCofig/thunks';
import { useChapterArticleLevel, useOneStoryWithAi } from 'store/StoryAiCofig/selectors';
import { useTabletDetection } from 'containers/chat/hooks';
import { invokeTrafficView, revokeTrafficModal } from "store/wheel/actions";
import { useTraffic } from "store/wheel/selectors";
import WidgetsAssignmentStory from "components/WidgetsAssignmentStory";
import AssignmentPhotoCollage from 'modules/activityModule/photoCollage';
import * as Sentry from '@sentry/react';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SentryWrap from 'components/Sentry';
import StudentPictureAssignment from './forms/assignment/picture/studentPictureAssignment';
import { useStandardExams } from 'store/standardexams';
import CountdownTimer from 'components/CountdownTimer';
import { SPANISH_ITEM_LOWER, SPANISH_ITEM_UPPER } from "utils/config/reference";
import { useUserProfileConfig } from 'store/users/selectors';
import useBadWords from 'components/hooks/words/badWords';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useGrade } from 'components/hooks/gradeCalculate/useGrade';
import { useStudentHaveDiff } from 'components/hooks/students/useStudentHaveDiff';
import { updateUI } from 'store/UI/actions';
import queryString from 'query-string';
import { checkStandardExam } from 'utils/methods/textMethod';
import { logToSentry } from 'utils/networkErrorUtils';
import { assignmentStatusDocumentId } from 'utils/methods/assignmentStatusFirestore';
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
import { firebaseApp } from 'firebaseConfig';
import { useBookUnits } from 'store/booksUnits/selectors';
import { useAssignmentSessionTracking } from 'hooks/useAssignmentSessionTracking';
import { useAssignmentSessionReplay } from 'hooks/useAssignmentSessionReplay';
import * as SubmissionsActions from 'store/submissions/actions';
var isInSubmit = null;
const wait_timmer = 1000
const OPTION_LABEL =['a)', 'b)', 'c)', 'd)', 'e)', 'f)', 'g)', 'h)', 'i)', 'j)'];
let debounceAssignmentSubmission = null;

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const AssignmentDescription = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
`;

const AssignmentTitle = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
`;

const Bar = styled.div`
    background-color: ${p => p.complete ? COLOR.green100 : COLOR.green800};
    flex: 1;
    height: 6px;
    margin-right: 4px;
    transition: all 500ms ease;

    &:last-child {
        margin-right: 0px;
    }
`;

const BarContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
`;



const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: ${p => p.active ? 'auto' : '0px'};
    margin-top: ${p => p.active ? '0px' : '24px'};
    max-width: ${p => p.maxWidth ? `${p.maxWidth}px` : "auto"};
    opacity: ${p => p.active ? 1 : 0};
    overflow: visible;
    transition margin-top 500ms ease, opacity 500ms ease;
    width: 100%;
    z-index: 1;
`;

const Content = styled.div`
    // margin-top: 24px;
    margin-top: 15px;
    .se-toolbar,
    .se-wrapper,
    .se-container,
    .se-wrapper-inner,
    .se-editor {
        background-color: #f0f0f0;
    }
`;

const Detail = styled(AssignmentDescription)`
    color: ${COLOR.black500};
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
`;

const Option = styled.button`
    background-color: ${p => p.selected ? COLOR.green800 : COLOR.white};
    border: 1px dashed ${p => p.selected ? COLOR.green300 : COLOR.black700};
    border-radius: 3px;
    color: ${p => p.selected ? COLOR.white : COLOR.black};
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;
    padding: 4px 6px;
    outline: none;
    text-align: left;
    transition: all 300ms ease;
    width: 90%;
    word-wrap: break-word;
    flex: 1;

    &:hover {
        box-shadow: ${p => p.selected ? 'none' : '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'};
        color: '${p => p.selected ? COLOR.green100 : COLOR.black200}';
    }
`;

const OptionLabel = styled.span`
    display: inline-block;
    width: 8px;
    text-align: right;
    margin-right: 8px;
`;

const Question = styled(AssignmentTitle)`
    font-size: 16px;
    line-height: 22px;
    
        ol, ul {
        padding-left: 30px;
        margin: 10px 0;
    }
    
    ol {
        list-style-type: decimal;
    }
    
    ul {
        list-style-type: disc;
    }
    
    li {
        margin: 5px 0;
        line-height: 1.5;
    }
    
    p {
        margin: 0px 0;
    }
`;

const QuestionContainer = styled(Container)`
    margin-top: 12px;
    position: relative;
    padding-bottom: 0px;
`;

const RelativeContainer = styled.div`
    position: relative;
    width: 100%;
    // margin-bottom: 10px;
`;

const Section = styled.div`
    // margin-bottom: 48px;
     margin-bottom: 15px;
    width: 100%;
`;

const SectionHeader = styled.span`
    border-bottom: 1px dashed ${COLOR.black700};
    color: ${COLOR.green100};
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.075em;
    margin-bottom: 10px;
    padding-bottom: 4px;
    text-transform: uppercase;
    width: 100%;
    display: flex;
    align-items: center;
`;
const TimmerWrapper = styled.div`
  color: ${COLOR.black100};
  //   font-size: 18px;
  font-weight: 600;
  line-height: 1.334;
  letter-spacing: 0em;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65%;

  @media screen and (max-width: 1200px) {
    width: 80%;
  }
`;

const TimmerWrappersection = styled.div`
  color: ${COLOR.black100};
  //   font-size: 18px;
  font-weight: 600;
  line-height: 1.334;
  letter-spacing: 0em;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom:15px;
`;

const Success = styled.span`
    color: ${COLOR.blac400};
    font-size: 16px;
    font-weight: 600
`;

const Wrap = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const Wrapper = styled.div`
    height: 100%;
    // max-width: 480px;
    max-width: 100%;
    padding: 0px 16px 0px;
    width: 100%;
    overflow-y: auto;
    height: 95%;
    margin-top: 10px;
`;

const LoaderContainer = styled.div`
  margin-top: "0px";
  opacity: 1;
  transition: all 300ms ease;
`;

const LoadingDiv = styled.div`
  display: flex;
  justify-content: center;
`;
const bounce = keyframes`
    to {
        opacity: 0.3;
        transform: translate3d(0, -0.3rem, 0);
    }
`;

const CircleDiv = styled.div`
  width: 8px;
  height: 8px;
  margin: 10px 0.3rem;
  background: ${COLOR.green100};
  border-radius: 50%;
  animation: 0.6s ${bounce} infinite alternate;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;

const AssignmentPlan = styled.button`
    background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 8px;
    white-space: nowrap;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
`;

const getFillingBlankCountForOption = (question, optId) => {
    const hl = question?.highlightWords?.[optId];
    if (!Array.isArray(hl)) return 0;
    return hl.flat(Infinity).filter((h) => h != null && typeof h === 'object').length;
};

const fillingAnswerSlotHasValue = (slot) => {
    const a = slot?.answer;
    return a !== undefined && a !== null && String(a).trim() !== '';
};

const isFillingQuestionFullyAnswered = (question, selectionAnswer) => {
    const raw = selectionAnswer?.selected_answer;
    if (raw == null) return false;
    const options = get(question, 'options', []) || [];
    const optionCount = Array.isArray(options) ? options.length : 0;
    if (optionCount === 0) return false;

    const slotsForOption = (optId) => {
        if (raw != null && typeof raw === 'object' && !Array.isArray(raw)) {
            return raw[optId];
        }
        if (Array.isArray(raw) && optId === 0) {
            if (raw.length > 0 && !Array.isArray(raw[0]) && raw[0] != null && typeof raw[0].answer !== 'undefined') {
                return raw;
            }
            if (raw.length > 0 && Array.isArray(raw[0])) {
                return raw.flat();
            }
        }
        return null;
    };

    for (let optId = 0; optId < optionCount; optId += 1) {
        const need = getFillingBlankCountForOption(question, optId);
        if (need === 0) {
            continue;
        }
        const slots = slotsForOption(optId);
        if (!Array.isArray(slots) || slots.length < need) {
            return false;
        }
        for (let i = 0; i < need; i += 1) {
            if (!fillingAnswerSlotHasValue(slots[i])) {
                return false;
            }
        }
    }
    return true;
};

const Assignment = ({
    isDrawerOpen = false,
    toggleDrawer = () => {},
    chapter,
    currentClass,
    currentOrg,
    currentSubmission,
    currentUser,
    data,
    onClose,
    page,
    retakes,
    interactions,
    userRol,
    setSubmitRef,
    timmer,
    onFinish,
    dueDate,
    redirectTo,
    shuffle,
    timeInt,
    is_extension_activity = false,
    getCurrentExtensionActivityData = () =>{},
    closeExtensionActivity = () => {},
    onNavigateToPage = () => {},
    closeSideDrawer = () => {},
}) => {
    const dispatch = useDispatch();
    const store = useStore();
    const location = useLocation();
  	const navigate = useNavigate();
    const servertime = useServertime()
    const timezone = useOrgTimezone()
    const currentClassTeacher = useCurrentClassTeacher()
    const { createCollectionSubmission } = useCollectionAutoSubmission()
    const standard_exams = useStandardExams();
    const isStandardExam = useMemo(() => checkStandardExam(chapter,standard_exams), [chapter,standard_exams])  
    const { invokeStoryView, revokeStoryView } = useStoryView();
    const [storyAILoader, setStoryAILoader] = useState(false);
    const [levelAILoader, setLevelAILoader] = useState(false);
    const [step, setStep] = useState(0);
    const [question, setQuestion] = useState(0);
    const [selectedQ, setSelectedQ] = useState(false);
    const [selections, setSelections] = useState([]);
    const [stepAlreadySet, setStepAlreadySet] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [trackingSessionEnded, setTrackingSessionEnded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [shuffledQuestions, setShuffledQuestions] = useState([]);
    const [selectedFillAnswers, setSelectedFillAnswers] = useState({});
    const { socketConnection, reCreateSocket } = useSocket();
    const [finishlaterAlert, setFinishLaterAlert] = useState({ open: false, message: "" })
    const [pageSelectionModal, setPageSelectionModal] = useState({ open: false, fromPage: null, toPage: null, isInRange: true })
    const hasAutoShownPageSelectionModalRef = useRef(false)
    const pageSelectionNavigateTimeoutRef = useRef(null)
    const [isSpanish, setIsSpanish] = useState(false)
    const classQuizzes = useClassQuizzes()
    const classActivities = useClassActivities()
    const activeUrl = useActiveClassUrl();
    const booksAllList = useAllBook()
    const audioRef = useRef();
    const videoRef = useRef();
    const navigateRef = useRef(navigate);
    const blockedNavigationRef = useRef(false);
    const isTeacherMoveRef = useRef(false);
    const currentBasePathRef = useRef(null);
    const currentChapterRef = useRef(null);
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const pageInteractions = filter(interactions, x => (x.chapter === chapter && x.page === page));
    const assignment = (data?.typeId == "quiz") ? find(classQuizzes, { quizId: data.id }) : find(classActivities, { activityId: data.id });
    const assignmentResumeContext = useMemo(() => {
        if (userRol !== 'student' || !data?.id || completed || trackingSessionEnded) return false;
        try {
            if (localStorage.getItem(`finishLater_${data.id}`) === 'true') return true;
        } catch {
        }
        const submissionCompleteTruthy =
            currentSubmission?.complete === true ||
            currentSubmission?.complete === 1 ||
            currentSubmission?.complete === '1' ||
            (typeof currentSubmission?.complete === 'string' &&
                String(currentSubmission.complete).toLowerCase() === 'true');
        if (currentSubmission?.id && !submissionCompleteTruthy) {
            const fl = currentSubmission.finishlater;
            if (fl != null && fl !== '') {
                const n = parseInt(fl, 10);
                if (!Number.isNaN(n) && n >= 0) return true;
            }
        }
        return false;
    }, [userRol, data?.id, completed, trackingSessionEnded, currentSubmission?.id, currentSubmission?.complete, currentSubmission?.finishlater]);
    const handleActivityLogIdSynced = useCallback(
        (logId) => {
            if (!currentSubmission?.id || !logId) return;
            dispatch(
                SubmissionsActions.updateSubmissionSuccess({
                    ...currentSubmission,
                    log_id: logId,
                })
            );
        },
        [currentSubmission, dispatch]
    );
    const assignmentScheduleFlushRef = useRef(null);
    const assignmentFlushNowRef = useRef(null);
    const assignmentSessionReplay = useAssignmentSessionReplay({
        enabled: Boolean(
            userRol === 'student' && data?.id && currentClass?.id && currentUser?.id
        ),
        assignmentId: data?.id,
        submissionId: currentSubmission?.id,
        activityLogId: currentSubmission?.log_id,
        serverMetaData: currentSubmission?.meta_data,
        submissionComplete: currentSubmission?.complete,
        completedSubmissionsCount: currentSubmission?.submissions,
        resumeContext: assignmentResumeContext,
        sessionEnded: trackingSessionEnded || completed,
        onRequestMetaFlush: () => assignmentScheduleFlushRef.current?.(),
        onRequestImmediateFlush: () => assignmentFlushNowRef.current?.(),
    });
    const assignmentTracking = useAssignmentSessionTracking({
        enabled: Boolean(
            userRol === 'student' && data?.id && currentClass?.id && currentUser?.id
        ),
        assignmentId: data?.id,
        userId: currentUser?.id,
        classId: currentClass?.id,
        submissionId: currentSubmission?.id,
        serverMetaData: currentSubmission?.meta_data,
        resumeContext: assignmentResumeContext,
        submissionComplete: currentSubmission?.complete,
        completedSubmissionsCount: currentSubmission?.submissions,
        sessionEnded: trackingSessionEnded || completed,
        onLogIdSynced: handleActivityLogIdSynced,
        getExtraMeta: assignmentSessionReplay.getMetaForSync,
        onBeforeFlush: assignmentSessionReplay.onBeforeFlush,
    });
    assignmentScheduleFlushRef.current = assignmentTracking.scheduleFlushToServer;
    assignmentFlushNowRef.current = assignmentTracking.flushToServer;
    const grade_type = assignment?.grade_type;
    const isCompleteInComplete = grade_type === "complete_incomplete"
    const max_point = assignment?.max_point && !isNaN(assignment?.max_point) && (assignment?.max_point>0)? Number.parseInt(assignment.max_point, 10) : 100
    const isPointSystem =  grade_type === "points"
    const [openImageViewModal,setOpenImageViewModal] = useState(false);
    const [assignmentCreationLoading, setAssignmentCreationLoading] = useState(false)
    const currentSubmissionRef = useRef(currentSubmission);
    const submissionProgressRef = useRef(currentSubmission);
    const closedByFirestoreStatusRef = useRef(false);
    const finalSubmittedRef = useRef(false);
    const isTablate = useTabletDetection();
    const {createCollectionNotification} = useCollectionNotification();
    const [openImageFillBlanks,setImageFillBlanks] = useState({});
    const assessmentRefs = useRef(null);
    const [currentGroupAudio, setCurrentGroupAudio] = useState(null);
    const [shouldAutoPlayGroupAudio, setShouldAutoPlayGroupAudio] = useState(false);
    const audioPlayersRef = useRef(new Map());
    const lastStepRef = useRef(step);
    const disableGroupAudioAutoplayOnceRef = useRef(false);
    const [textEditorData,setTextEditorData] = useState("");
    const keepAssignmentPageAfterSubmitRef = useRef(false);
    const [buttonDisabled,setButtonDisabled] = useState(false);
    const buttonDisabledRef = useRef(buttonDisabled);
    buttonDisabledRef.current = buttonDisabled;
    const [showRecordingAlert, setShowRecordingAlert] = useState(false);
    const { checkPopUpAtOnce, updatePopUpAtOnce } = usePopUpAtOnce();
    const [trafficModal] = useTraffic();
    const [showCountdownTimer, setShowCountdownTimer] = useState(false);
    const { isAiPermissionEnabled } = useUserProfileConfig();   
    const { checkBadWords,getTextFromHtml } = useBadWords('assignment');
    const showAlert = useAlert();
    const [loadingWidget, setLoadingWidget] = useState(false);
    const [currentSubmissionData, setCurrentSubmissionData] = useState(null);
    const {checkCorrectMultipleResponse} = useGrade();
    const { studentHaveDiffOnAssignment } = useStudentHaveDiff({ assignment, studentId: currentUser?.id });
    const searchParams = useMemo(() => queryString.parse(location.search), [location.search]);
    const currentPage = useMemo(() => searchParams?.page, [searchParams]);
    const assignmentPage = useMemo(() => assignment?.data?.page, [assignment?.data?.page]);
    const isOnSamePage = useMemo(() =>pageSelectionModal.fromPage == pageSelectionModal.toPage && currentPage == pageSelectionModal.fromPage && currentPage == assignmentPage, [currentPage, assignmentPage,pageSelectionModal]);
    const has_manual_grading = useMemo(() => checkIsManualGradable(data?.questions), [data?.questions]);

    const bookUnitList = useBookUnits()
    const BALCON_PAGES = get(find(bookUnitList, ["bookId", chapter]), "pages", [])

    const getNumberMaskForAll = useCallback((_page) => {
        const balconPage = BALCON_PAGES.find(p => {
            const startNum = parseInt(p.start, 10);
            const finishNum = parseInt(p.finish, 10);
            const pageNum = parseInt(_page, 10);
            return startNum <= pageNum && finishNum >= pageNum;
        });
        
        if (balconPage) {
            const pageNum = parseInt(_page, 10);
            const startNum = parseInt(balconPage.start, 10);
            return pageNum - startNum + 1;
        }
        
        if (isEbook(chapter, booksAllList)) {
            return getNumberMask(chapter, _page, booksAllList);
        }
    }, [chapter, BALCON_PAGES, booksAllList])
    
    const forMobile = window.innerWidth < 520 || (window.innerWidth >= 809 && window.innerWidth <= 1441);
    const pas_sub = useMemo(() => {
        const has_past = currentSubmission && Array.isArray(currentSubmission.pastSubmissions) && currentSubmission.pastSubmissions.length > 0
        return ({
            has_past,
            pastSubmissions: has_past ? currentSubmission.pastSubmissions : []
        })
    }, [currentSubmission])
    const view_result = useMemo(() => {
        const result_visibility_on = assignment?.result_visibility_on;
        if (!result_visibility_on) return true;
        return !dayjs().isBefore(dayjs(result_visibility_on));
    }, [assignment?.result_visibility_on])
    const closeFeedback = async () => {
        await dispatch(revokeTrafficModal(25));
    }
    const book_story = useOneStoryWithAi();
    const book_artilce_level = useChapterArticleLevel()
    const scrollToAssessment = () => {
        if (window.innerWidth < 769) {
            if (assessmentRefs.current) {
                assessmentRefs.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    };

    const scrollToAssignment = () => {
       
        const el = document.getElementById("instructionsScroll");
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
        
    };

    const assignmentIdForWidgetClear = data?.id ?? data?.data?.id;

    const storyResultMemo = useMemo(() => {
        let storyResult = null;
        if(Array.isArray(book_story) && book_story.length > 0){
            const has_soy_story = book_story.find((story) => story.id === data?.storyInstruction);
            if (has_soy_story && has_soy_story?.id) {
                storyResult = has_soy_story;
            }
        }
        return storyResult;
    }, [data?.storyInstruction, book_story])
    useEffect(() => {
        if (userRol !== 'student' || !assignmentIdForWidgetClear) {
            return;
        }
        const trafficModalState = store.getState()?.trafficModal;
        const trafficData = trafficModalState?.widget_menu ?? [];
        const existingWidget = find(trafficData, (item) => item?.menu === "assignment_story");
        if (existingWidget) {
            dispatch(revokeTrafficModal(existingWidget.id));
            // updatePopUpAtOnce(false);
        }
    }, [userRol, assignmentIdForWidgetClear, dispatch, store])
    const pauseAllOtherAudioPlayers = (currentPlayerRef) => {
        audioPlayersRef.current.forEach((playerRef, key) => {
            if (playerRef !== currentPlayerRef && playerRef?.current) {
                try {
                    const internalPlayer = playerRef.current.getInternalPlayer();
                    if (internalPlayer && !internalPlayer.paused) {
                        internalPlayer.pause();
                    }
                } catch (error) {
                }
            }
        });
    };

    useEffect(() => {
        if (!currentSubmission?.id) return;
        const assignmentId = data?.id ?? data?.data?.id;
        const openStoryKey = assignmentId ? `open_story_ai_${assignmentId}` : null;
        const skipStoryKey = assignmentId ? `skip_story_ai_${assignmentId}` : null;
        if (openStoryKey && localStorage.getItem(openStoryKey) === "true") {
            localStorage.removeItem(openStoryKey);
            if (storyResultMemo) {
                fetchStoryAI("clickEvent");
            }
            return;
        }
        if (skipStoryKey && localStorage.getItem(skipStoryKey) === "true") {
            localStorage.removeItem(skipStoryKey);
            return;
        }
        if(!storyResultMemo) return;
        fetchStoryAI();
    }, [currentSubmission?.id, data?.id, storyResultMemo]);

    const fetchCurrentSubmissionData = async () => {
      try {
        const response = await dispatch(
          handleGetSumissionById({
            userId: currentUser?.id,
            classId: currentClass?.id,
            submissionId: currentSubmission?.id,
          }),
        );
        setCurrentSubmissionData(response);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
        if (!currentSubmission?.id) {
            setCurrentSubmissionData(null);
            return;
        }
        fetchCurrentSubmissionData();
    }, [currentSubmission?.id]);

    useEffect(() => {
      if (assignment?.data?.id && currentUser?.role === 'student') {
        const finishLaterClicked = localStorage.getItem(`finishLater_${assignment.data.id}`);
        if (finishLaterClicked === 'true') {
          setShowCountdownTimer(true);
        }
      }
    }, [assignment?.data?.id, currentUser?.role]);
    const aiConfig = get(data, 'ai_grading_config', {});
    const pageSelectionFrom = aiConfig.page_selection_from != null ? parseInt(aiConfig.page_selection_from, 10) : null;
    const pageSelectionTo = aiConfig.page_selection_to != null ? parseInt(aiConfig.page_selection_to, 10) : null;
    const currentPageNum = page != null ? parseInt(page, 10) : null;
    
    const isPageInSelectionRange = useMemo(() => {
      return currentPageNum != null && pageSelectionFrom != null && pageSelectionTo != null &&
        currentPageNum === pageSelectionFrom;
    }, [currentPageNum, pageSelectionFrom, pageSelectionTo]);

    const assignmentIdForPageModal = assignment?.data?.id ?? data?.id;
    const navigateToAssignmentPage = useCallback(() => {
      const targetPage =
        data?.page != null
          ? parseInt(data.page, 10)
          : page != null
            ? parseInt(page, 10)
            : pageSelectionFrom != null
              ? parseInt(pageSelectionFrom, 10)
              : null;
      if (targetPage == null || Number.isNaN(targetPage)) return;
      onNavigateToPage(targetPage, null, null);
    }, [data?.page, onNavigateToPage, page, pageSelectionFrom]);

    useEffect(() => {
      hasAutoShownPageSelectionModalRef.current = false;
    }, [assignmentIdForPageModal]);

    useEffect(() => {
      if (currentUser?.role !== 'student' || pageSelectionFrom == null || pageSelectionTo == null) return;
      if (hasAutoShownPageSelectionModalRef.current) return;
      if (currentSubmission?.answers?.length > 0 || currentSubmission?.finishlater !== null) return;
      hasAutoShownPageSelectionModalRef.current = true;
      setPageSelectionModal({
        open: true,
        fromPage: pageSelectionFrom,
        toPage: pageSelectionTo,
        isInRange: isPageInSelectionRange
      });
      if (!isPageInSelectionRange) {
        if (pageSelectionNavigateTimeoutRef.current) {
          clearTimeout(pageSelectionNavigateTimeoutRef.current);
          pageSelectionNavigateTimeoutRef.current = null;
        }

        const activityId = data?.typeId === 'quiz' ? null : assignmentIdForPageModal;
        const quizId = data?.typeId === 'quiz' ? assignmentIdForPageModal : null;

        pageSelectionNavigateTimeoutRef.current = setTimeout(() => {
          pageSelectionNavigateTimeoutRef.current = null;
          onNavigateToPage(parseInt(pageSelectionFrom, 10), activityId, quizId);
        }, 1500);

        return () => {
          if (pageSelectionNavigateTimeoutRef.current) {
            clearTimeout(pageSelectionNavigateTimeoutRef.current);
            pageSelectionNavigateTimeoutRef.current = null;
          }
          hasAutoShownPageSelectionModalRef.current = false;
        };
      }
    }, [pageSelectionFrom, pageSelectionTo, currentUser?.role, currentSubmission?.id, currentSubmission?.answers?.length, isPageInSelectionRange, assignmentIdForPageModal, data?.typeId]);

    useEffect(() => {
        navigateRef.current = navigate;
    }, [navigate]);

    useEffect(() => {
        if (activeUrl && currentUser?.role === 'student') {
            isTeacherMoveRef.current = true;
            const timeout = setTimeout(() => {
                isTeacherMoveRef.current = false;
            }, 3000);
            return () => clearTimeout(timeout);
        }
    }, [activeUrl, currentUser?.role]);

    useEffect(() => {
        if (buttonDisabled && !currentBasePathRef.current) {
            const pathname = location.pathname;
            const basePath = pathname.split('/').filter(Boolean)[0] || pathname;
            currentBasePathRef.current = `/${basePath}`;
            const searchParams = queryString.parse(location.search);
            currentChapterRef.current = searchParams.chapter || null;
        } else if (buttonDisabled && currentBasePathRef.current) {
            const searchParams = queryString.parse(location.search);
            const newChapter = searchParams.chapter || null;
            if (newChapter !== currentChapterRef.current) {
                currentChapterRef.current = newChapter;
            }
        } else if (!buttonDisabled) {
            currentBasePathRef.current = null;
            currentChapterRef.current = null;
            blockedNavigationRef.current = false;
            return;
        }

        const getBasePath = (pathname) => {
            const parts = pathname.split('/').filter(Boolean);
            return parts.length > 0 ? `/${parts[0]}` : pathname;
        };

        const getChapterFromUrl = (url) => {
            try {
                const urlObj = typeof url === 'string' ? new URL(url, window.location.origin) : url;
                const searchParams = queryString.parse(urlObj.search);
                return searchParams.chapter || null;
            } catch {
                return null;
            }
        };

        const isSameBasePathAndChapter = (newPathname, newSearch = '') => {
            const newBasePath = getBasePath(newPathname);
            
            let searchString = newSearch;
            if (!searchString) {
                if (newPathname.includes('?')) {
                    const parts = newPathname.split('?');
                    searchString = `?${parts[1]}`;
                } else {
                    searchString = window.location.search;
                }
            }
            
            const searchParams = searchString ? queryString.parse(searchString.startsWith('?') ? searchString.substring(1) : searchString) : {};
            const newChapter = searchParams.chapter || null;
            
            const basePathMatch = newBasePath === currentBasePathRef.current;
            const chapterMatch = currentChapterRef.current === null || newChapter === currentChapterRef.current;
            
            return basePathMatch && chapterMatch;
        };

        const handleBeforeUnload = (e) => {
            if (!isTeacherMoveRef.current) {
                e.preventDefault();
                e.returnValue = '';
                setShowRecordingAlert(true);
                return '';
            }
        };

        const handlePopState = (e) => {
            if (!blockedNavigationRef.current && !isTeacherMoveRef.current) {
                const newPathname = window.location.pathname;
                const newSearch = window.location.search;
                if (!isSameBasePathAndChapter(newPathname, newSearch)) {
                    e.preventDefault();
                    setShowRecordingAlert(true);
                    window.history.pushState(null, '', window.location.href);
                }
            }
        };

        const handleClick = (e) => {
            const anchor = e.target.closest('a[href]');
            if (anchor && anchor.href && !anchor.href.startsWith('javascript:') && !anchor.href.startsWith('#')) {
                const currentOrigin = window.location.origin;
                const anchorOrigin = new URL(anchor.href).origin;
                if (anchorOrigin === currentOrigin && anchor.target !== '_blank') {
                    if (!blockedNavigationRef.current && !isTeacherMoveRef.current) {
                        const anchorUrl = new URL(anchor.href);
                        const anchorPathname = anchorUrl.pathname;
                        const anchorSearch = anchorUrl.search;
                        if (!isSameBasePathAndChapter(anchorPathname, anchorSearch)) {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowRecordingAlert(true);
                        }
                    }
                }
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('popstate', handlePopState);
        document.addEventListener('click', handleClick, true);

        const originalPushState = window.history.pushState.bind(window.history);
        const originalReplaceState = window.history.replaceState.bind(window.history);

        window.history.pushState = function(...args) {
            if (!blockedNavigationRef.current && !isTeacherMoveRef.current) {
                const url = args[2];
                if (url) {
                    try {
                        const urlObj = url.startsWith('http') ? new URL(url) : new URL(url, window.location.origin);
                        if (!isSameBasePathAndChapter(urlObj.pathname, urlObj.search)) {
                            setShowRecordingAlert(true);
                            return;
                        }
                    } catch (error) {
                    }
                }
            }
            return originalPushState(...args);
        };

        window.history.replaceState = function(...args) {
            if (!blockedNavigationRef.current && !isTeacherMoveRef.current) {
                const url = args[2];
                if (url) {
                    try {
                        const urlObj = url.startsWith('http') ? new URL(url) : new URL(url, window.location.origin);
                        if (!isSameBasePathAndChapter(urlObj.pathname, urlObj.search)) {
                            setShowRecordingAlert(true);
                            return;
                        }
                    } catch (error) {
                    }
                }
            }
            return originalReplaceState(...args);
        };

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('popstate', handlePopState);
            document.removeEventListener('click', handleClick, true);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [buttonDisabled, location.pathname, location.search]);

    useEffect(() => {
        return () => {
            if (buttonDisabledRef.current) {
                if (audioRef.current && typeof audioRef.current.stop === 'function') {
                    try {
                        audioRef.current.stop();
                    } catch (error) {
                    }
                }
                if (videoRef.current && typeof videoRef.current.stop === 'function') {
                    try {
                        videoRef.current.stop();
                    } catch (error) {
                    }
                }
            }
        };
    }, []);

    useEffect(()=>{
        const prevStep = lastStepRef.current;
        const isGoingForward = step > prevStep;
        const shouldAllowGroupAudioAutoplay = isGoingForward && !disableGroupAudioAutoplayOnceRef.current;
        disableGroupAudioAutoplayOnceRef.current = false;

        const question =Array.isArray(shuffledQuestions)?shuffledQuestions[step]:null;
        if(question){
            if (question.type === 'audioMultipleChoice') {
                const groupAudio = (data?.questions || []).find(
                    q => q.groupKey === question.groupKey && q.type === 'audioMultipleChoice'
                )?.audio;

                const nextGroupAudio = {
                    audio: groupAudio,
                    groupKey: question.groupKey,
                    instanceKey: `${question.groupKey ?? 'group'}-${groupAudio ?? ''}`,
                };

                if (!currentGroupAudio || currentGroupAudio.instanceKey !== nextGroupAudio.instanceKey) {
                    setCurrentGroupAudio(nextGroupAudio);
                    const groupAudioKey = `group-${nextGroupAudio.instanceKey}`;
                    if (audioPlayersRef.current.has(groupAudioKey)) {
                        audioPlayersRef.current.get(groupAudioKey).hasAutoPlayed = false;
                    }
                }

                setShouldAutoPlayGroupAudio(shouldAllowGroupAudioAutoplay);
            }else if (question.type === 'audioEssay') {
                if (question.groupKey) {
                    const groupAudio = (data?.questions || []).find(
                        q => q.groupKey === question.groupKey && q.type === 'audioEssay'
                    )?.audio;
                    const nextGroupAudio = {
                        audio: groupAudio,
                        groupKey: question.groupKey,
                        instanceKey: `${question.groupKey ?? 'group'}-${groupAudio ?? ''}`,
                    };
                    if (!currentGroupAudio || currentGroupAudio.instanceKey !== nextGroupAudio.instanceKey) {
                        setCurrentGroupAudio(nextGroupAudio);
                    }
                    setShouldAutoPlayGroupAudio(false);
                } else {
                    setCurrentGroupAudio(null);
                    setShouldAutoPlayGroupAudio(false);
                }
            }
            else{
                setCurrentGroupAudio(null);
                setShouldAutoPlayGroupAudio(false);
            }
        }
        lastStepRef.current = step;
    },[step,shuffledQuestions])
    useEffect(()=>{
        currentSubmissionRef.current = currentSubmission;
        submissionProgressRef.current = currentSubmission;
        if (currentSubmission) {
            // AutoSubmissionFirebase(currentSubmission)
        }
    },[currentSubmission])

    useEffect(() => {
        closedByFirestoreStatusRef.current = false;
    }, [data?.id, data?.typeId, currentClass?.id]);

    useEffect(() => {
        if (is_extension_activity) return undefined;
        if (userRol !== 'student' || !data?.id || !currentClass?.id) return undefined;
        const kind = data?.typeId === 'quiz' || data?.typeId === 'quizresource' ? 'quiz' : 'activity';
        const db = getFirestore(firebaseApp);
        const statusRef = doc(
            db,
            'assignment_status',
            assignmentStatusDocumentId(currentClass.id, kind, data.id),
        );
        const unsub = onSnapshot(
            statusRef,
            (snap) => {
                if (!snap.exists()) return;
                if (snap.data()?.active !== false) return;
                const sub = submissionProgressRef.current;
                const started = Boolean(sub?.id && !sub.complete);
                if (!started || closedByFirestoreStatusRef.current) return;
                closedByFirestoreStatusRef.current = true;
                try {
                    showAlert('This assignment is no longer active. Your session was closed.', 'error');
                } catch (err) {
                    Sentry.captureException(err);
                }
                if (typeof onClose === 'function') onClose();
                if (typeof closeSideDrawer === 'function') closeSideDrawer();
            },
            () => {},
        );
        return () => unsub();
    }, [userRol, data?.id, data?.typeId, currentClass?.id, is_extension_activity, showAlert, onClose, closeSideDrawer]);
    const updateOnInterval = debounce((submission_value) => {
        if (submission_value.length > 0) {
            updateAnswers(false,false,false,submission_value)
        }
    }, 3000)

    const AutoSubmissionFirebase = (submission_value) => {
        if (!currentSubmission) return;
        const submissionWithUser = {
            ...currentSubmission,
            user: currentSubmission?.user || currentUser,
        };
        const submissionId = currentSubmission?.assignmentId + currentSubmission?.userId
        const data = {
            classId: get(currentClass, 'id', ''),
            userId: currentUser?.id,
            submissionData: submissionWithUser,
            submissionId,
            status: currentSubmission?.complete
        }
        createCollectionSubmission(data, submissionId)
    }

    const disableShuffle = (type) => {
      if (type) {
        switch (type) {
         case "match":
            return true;
          case "filling":
            return true;
        case "fillingImage":
            return true;
          default:
            return false;
        }
      }
    };

    useEffect(() => {
        let questions = get(data, "questions", []) || []
        questions = questions.map((question, i) => {
            if (question?.options) {
                const options = question?.options?.map((option, index) => ({ value: option, oldIndex: index }));
                return { ...question, oldIndex: i, options };
            } else {
                return { ...question, oldIndex: i };
            }
        })
        if (shuffle) {
            if (currentSubmission && parseInt(currentSubmission.finishlater) >= 0 && currentSubmission.finishlater != null) {
                const answeredArr=questions.filter((item,index)=>currentSubmission?.answers[index]!=null&&item)
                const remaining=questions.filter((item,index)=>currentSubmission?.answers[index]==null&&item)
                const shuffled = remaining.map((question) => {
                    if (question?.options && !disableShuffle(question.type)) {
                        return { ...question, options: shuffleArray(question.options) };
                    } else {
                        return question;
                    }
                });
                const completedOptionSuffle = answeredArr.map((question) => {
                    if (question?.options) {
                        return { ...question, options:shuffleArray(question.options) };
                    } else {
                        return question;
                    }
                });
                  const QuestionShuffle = shuffleArray(shuffled)
                  const CompQuestionShuffle = shuffleArray(completedOptionSuffle)
                  const completeShuffle = [...CompQuestionShuffle, ...QuestionShuffle]
                  setShuffledQuestions(completeShuffle);
            }else if(currentSubmission?.answers?.length>0){
                const alreadySubmitted = []
                const toBeSubmitted = []
                questions.forEach(item=>{
                    if(currentSubmission?.answers[item.oldIndex]!=null){
                        alreadySubmitted.push(item)
                    }else{
                        toBeSubmitted.push(item)
                    }
                })

                const shuffled = toBeSubmitted.map((question) => {
                    if (question?.options && !disableShuffle(question?.type)) {
                        return { ...question, options:shuffleArray(question.options) };
                    } else {
                        return question;
                    }
                });
                const completedOptionSuffle = alreadySubmitted.map((question) => {
                    if (question?.options && !disableShuffle(question?.type)) {
                        return { ...question, options:shuffleArray(question.options) };
                    } else {
                        return question;
                    }
                });
                  const QuestionShuffle = shuffleArray(shuffled)
                  const CompQuestionShuffle = shuffleArray(completedOptionSuffle)
                  const completeShuffle = [...CompQuestionShuffle, ...QuestionShuffle]
                  setShuffledQuestions(completeShuffle);
            }
             else {
             
                const shuffled = questions.map((question, i) => {
                    if (question?.options && !disableShuffle(question.type)) {
                        return { ...question , options: shuffleArray(question.options) };
                    } else {
                        return { ...question };
                    }
                  });
                  setShuffledQuestions(shuffleArray(shuffled));
            }
        } else {
            const shuffled = questions      
            setShuffledQuestions(shuffled);
        }
    }, [])

    useEffect(() => {
        if (currentSubmission) {
            if (currentSubmission.answers && currentSubmission.answers.length > 0 && selections.length == 0) {
                setSelections(currentSubmission.answers)
            }
        }
        if (step <= 0) {
            if (currentSubmission) {
                let currentSubLength = currentSubmission ?  currentSubmission?.answers?.filter(k=>k)?.length : 0
                currentSubLength = currentSubLength < data.questions.length ? currentSubLength : currentSubLength - 1

                if(currentSubmission?.complete){
                    return;
                }
                else if (currentSubmission && parseInt(currentSubmission.finishlater) >= 0 && currentSubmission.finishlater != null) {
                    setStep(parseInt(currentSubmission.finishlater))
                    forceUpdate()
                }
                 else {
                    const is_auto = currentSubmission?.is_auto;
                    let stp =  is_auto ? currentSubLength - 1 : currentSubLength;
                    stp = stp<0?0:stp
                    if(stepAlreadySet) return;
                    setStep(selectedQ ? question + 1 : stp ? stp : 0);
                    setStepAlreadySet(true)
                }

            }
        }

    }, [currentSubmission])

    useEffect(() => {
        if (currentSubmission && Array.isArray(currentSubmission.pastSubmissions) && currentSubmission.pastSubmissions.length > 0) {
            // Sort past submissions and get the one with the highest number of submissions
            const pastSubData = [...currentSubmission.pastSubmissions].sort((a, b) => parseInt(b.submissions) - parseInt(a.submissions))[0];
            const pastSub = JSON.parse(JSON.stringify(pastSubData));
            const currentQuestion = shuffledQuestions[step];

            // Check if the current question has an oldIndex property
            if (currentQuestion && has(currentQuestion, "oldIndex")) {
                const selectedAnswer = selections[currentQuestion.oldIndex];
                const currentSubmissionAnswer = currentSubmission.answers[currentQuestion.oldIndex];

                // If no selection is made, set the answers from currentSubmission
                if (!selectedAnswer) {
                    setSelections(currentSubmission.answers);
                }

                // If past submission exists, attempt to update the selection
                if (pastSub) {
                    if (!selectedAnswer) {
                        // If there's a finished answer in currentSubmission, use it
                        if (currentSubmissionAnswer) {
                            let updatedSelections = [...selections];

                            if (selections.length === 0) {
                                setSelections(currentSubmission.answers);
                                forceUpdate();
                            } else {
                                updatedSelections[currentQuestion.oldIndex] = currentSubmissionAnswer;
                                setSelections(updatedSelections);
                                forceUpdate();
                            }
                        }
                        // If there's an answer in past submissions, use that
                        else if (pastSub.answers[currentQuestion.oldIndex]) {
                            let updatedSelections = [...selections];

                            if (selections.length === 0) {
                                setSelections(pastSub.answers);
                                forceUpdate();
                            } else {
                                updatedSelections[currentQuestion.oldIndex] = pastSub.answers[currentQuestion.oldIndex];
                                setSelections(updatedSelections);
                                forceUpdate();
                            }
                        }
                    }
                }
            }
        }
    }, [currentSubmission, step, shuffledQuestions]);

    const handleChange = useCallback((answer, type, question) => {
        let data = [];
        data = selections.length > 0 ? selections : []
        data[question] = {
            answer: answer,
            type: type,
            is_correct: true
        }
        setSelections(data);
        updateOnInterval(data)
        forceUpdate();
    });
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => (isMounted.current = false);
    }, []);
    useEffect(() => {
        return () => {
            if (!isMounted.current) {
                if (timmer > 0) {
                    updateAnswers(true, null, true)
                }
            }
        }
    }, [timmer, isMounted]);
    function checkIsCorrect(qId,selectedOption,questionData){
        let isCorrect = false
        if(data.questions[qId].type === "multipleChoice" || data.questions[qId].type === "trueFalse" || data.questions[qId].type === "audioTrueFalse" || data.questions[qId].type === "audioMultipleChoice"){
            let expected_answer = questionData?.answer || data.questions[qId]?.answer;
            if (!isNaN(expected_answer)) {
                if (Number(expected_answer) == Number(selectedOption)) {
                    isCorrect = true;
                }
            } else {
                if (expected_answer == selectedOption) {
                    isCorrect = true;
                }
            }
        }else if(data.questions[qId].type === "multipleResponse"){
            const isCheck = checkCorrectMultipleResponse(data.questions[qId], selectedOption,studentHaveDiffOnAssignment);
            isCorrect = isCheck ? true : false;
        }else{
            isCorrect = true;   
        }
        return isCorrect
    }
    const checkIsCorrectMatch = (questionId, index, selectedRightValue) => {
        // Retrieve the question by ID
        const question = data.questions.find((q) => q.id === questionId);
        if (!question || !question.options || !question.options[index]) {
            return false; // Invalid question or index
        }
    
        // Check if the selected value matches the correct answer
        return question.options[index].right === selectedRightValue;
    };
    
    const handleImageSelect = useCallback((questionId, answer, imageUrl, type, categoryType) => {
        setSelectedQ(true);
        setQuestion(questionId);
        setSelections(prevSelections => {
          const newSelections = [ ...prevSelections ];
          const previousData = newSelections[questionId];
    
          let newData = {
            ...previousData,
            type: type, 
          };
    
          if (categoryType === "Image") {
            newData.imageUrl = imageUrl;
            newData.answer = ''; 
            newData.additionalImages = previousData?.additionalImages || [];
          } else if (categoryType === "ImageAndText") {
            newData.answer = answer || previousData?.answer || '';
            newData.imageUrl = imageUrl || previousData?.imageUrl || '';
            newData.additionalImages = previousData?.additionalImages || [];
          } else {
            newData.answer = answer || '';
          }
    
          newData.is_correct = true;
          newData.categoryType = categoryType;
    
          newSelections[questionId] = newData;
            if (!answer) {
                updateAnswers(false, false, false, newSelections)
            } else {
                updateOnInterval(newSelections)
            }
          return newSelections;
        });
        forceUpdate();
      }, [setSelections, checkIsCorrect, setQuestion, forceUpdate]);

    const handleAdditionalImages = useCallback((questionId, additionalImages, categoryType) => {
        setSelectedQ(true);
        setQuestion(questionId);
        setSelections(prevSelections => {
          const newSelections = [ ...prevSelections ];
          const previousData = newSelections[questionId];
    
          let newData = {
            ...previousData,
            type: previousData?.type || 'picture',
            imageUrl: previousData?.imageUrl || '',
            answer: previousData?.answer || '',
            additionalImages: Array.isArray(additionalImages) ? additionalImages : [],
            categoryType: categoryType || previousData?.categoryType || 'Image',
            is_correct: true
          };
    
          newSelections[questionId] = newData;
          updateAnswers(false, false, false, newSelections);
          return newSelections;
        });
        forceUpdate();
      }, [setSelections, setQuestion, forceUpdate]);


    const handleSelect = (question, answer, type,questionData) => {
        const questionDataCopy = cloneDeep(questionData);
        setQuestion(question);
        setSelectedQ(true);
        let data = [];
        data = selections.length > 0 ? selections : [];
        const options = questionDataCopy?.options?.sort((a,b)=>a.oldIndex-b.oldIndex);
        data[question] = {
            answer: answer,
            type: type,
            is_correct:  checkIsCorrect(question,answer,questionData),
            correct_answers: questionData?.answer,
            isStudentHaveDiff: studentHaveDiffOnAssignment,
            studentDiffOption: options
        }
        setSelections(data);  
        updateAnswers(false, null, false, data)
        forceUpdate();
    };

    const handleSelectMatch = (question, answer, type, match_data) => {
        setQuestion(question);
        setSelectedQ(true);
        let data = [];
        data = selections.length > 0 ? selections : []
        data[question] = {
            answer: answer,
            type: type,
            is_correct:  checkIsCorrect(question,answer),
            match_data
        }
        setSelections(data);  
        updateAnswers(false, null, false, data)
        forceUpdate();
    };

    const handleMatchSelection = useCallback((question, index, leftValue, rightValue) => {
        // Clone the existing question object or initialize if empty
        let questionId = question.id
        const updatedSelections = selections.length>0? [...selections] : [question];
        const currentQuestion = updatedSelections[questionId] || {};
    
        // Ensure options array exists and is properly structured
        if (!currentQuestion.options[index]) {
            currentQuestion.options[index] = {
                value: { left: null, right: null },
                oldIndex: index,
            };
        }
    
        // Update the specific option
        currentQuestion.options[index].value = {
            left: leftValue,
            right: rightValue,
        };
    
        // Update the is_correct property
        currentQuestion.options[index].is_correct = checkIsCorrectMatch(
            questionId,
            index,
            rightValue
        );

        // Replace the updated question in selections
        updatedSelections[questionId] = currentQuestion;
        // Update global state (e.g., answers or selections)
        setSelections(updatedSelections);
        updateAnswers(false, null, false, currentQuestion);
        forceUpdate(); // Trigger a re-render if necessary
    }, [selections, forceUpdate, checkIsCorrectMatch]);

    const shuffleOptions = (options) => {
        const shuffled = [...options];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };  
    const getMarksPerQuestion = () => {
        const max_value = isPointSystem ? max_point : 100;
        const number_of_questions = get(data, "questions.length", 0) || 0;
        return parseFloat(Number((max_value / number_of_questions).toFixed(2)));
    } 
    const gradeQuiz = () => {
        let total = 0;
        let correct = 0;
        let manualGrading = false
        const is_complete_tbg = checkIsManualGradable(shuffledQuestions)
        let calculated_grade = 0 ;
        let face_grade = 0
        const max_mark_per_question = getMarksPerQuestion();
            try {
                map(data.questions, (e, i) => {
                    if (selections[i] && selections[i].type === 'string') {
                        total++;
                        if (selections[i]?.answer == data.questions[i]?.answer) {
                            correct += 1;
                            calculated_grade += max_mark_per_question;
                        }
                    } else if (selections[i] && selections[i].type === 'array' && data.questions[i].type === 'multipleResponse') {
                        total++;
                        const result = checkCorrectMultipleResponse(data.questions[i], selections[i].answer, studentHaveDiffOnAssignment);
                        if (result) {
                            correct += 1;
                            calculated_grade += max_mark_per_question;
                        } 
                    } else if (selections[i] && (selections[i].type === 'match')) {
                        total++;
                        const data = selections[i]?.match_data;
                        const allCorrect = checkAllCorrectMatch(data,max_mark_per_question, e?.options);
                        if (allCorrect) {
                            correct += 1;
                            calculated_grade += parseFloat(allCorrect.mark);
                        }
                    } else if (selections[i] && (selections[i].type === 'filling' || selections[i].type === 'fillingImage')) {
                        total++;
                        const data = selections[i]?.selected_answer;
                        // const allCorrect = checkAllCorrect(data,max_mark_per_question);
                        // if(allCorrect){
                        //     correct += 1;
                        //     calculated_grade += parseFloat(allCorrect.mark);
                        // }
                        const fillResult = checkAllCorrect(data, max_mark_per_question);                  
                        correct += fillResult.correct ?? 0;
                        calculated_grade += parseFloat(fillResult.mark ?? 0);
                    }
                    else {
                        manualGrading = true;
                    }
                })
            } catch (error) {
                console.log(error, "error in calculating grade");
                Sentry.captureException(`495 Error in gradeQuiz: ${error}`);
            }
            // let grade = total > 0 ? ((correct / total) * 100).toFixed(0) : 0;
            // grade = isCompleteInComplete ? 100 : Number(calculated_grade).toFixed(0);
            // manualGrading = isCompleteInComplete ? false : manualGrading
            // const pointPerQuestion = ((max_point||100) / total);
            // face_grade = isPointSystem ?Math.round(correct * pointPerQuestion) : grade
        let per_grade = (calculated_grade / max_point) * 100;
        let grade = isCompleteInComplete ? 100 : Number(per_grade).toFixed(0);
        manualGrading = isCompleteInComplete ? false : manualGrading
        face_grade = Number(calculated_grade).toFixed(0);
        return ({ grade: is_complete_tbg && grade == 0 ? null : Math.round(grade), manualGrading, face_grade: is_complete_tbg && face_grade == 0 ? null : Math.round(face_grade) })
    };

    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            console.log(error, "error")
            Sentry.captureException(`496 Error in sendNotifications: ${error}`);
        }
    }

    const invokSend = (data) => {
        let socket = socketConnection ?? '';
        if (socket) {
            try {
                if (socket.readyState == 3) {
                    reCreateSocket()
                    setTimeout(() => {
                        socket.send(JSON.stringify(data))
                    }, 2000)
                } else {
                    socket.send(JSON.stringify(data))
                }
            } catch (error) {
                console.log(error, "error")
                Sentry.captureException(`497 Error in invokSend: ${error}`);
            }
        }
    }
    function compareAnswer(ans1, ans2) {
        try {
            if(!ans1) return false;
            let eq = false;
            if (Array.isArray(ans1) && Array.isArray(ans2)) {
                if (ans1.length == ans2.length) {
                    eq = true
                    ans1.forEach((a, i) => {
                        if (!a && !ans2[i]) {
                            return
                        }
                        if (!a || !ans2[i]) {
                            eq = false
                            return
                        }
                        if (a.type == "ImageAndText") {
                            if ((a.imageUrl != ans2[i]?.imageUrl) || a?.answer != ans2[i]?.answer) {
                                eq = false
                            }
                        } else if (a.type == "Image") {
                            if (a.imageUrl != ans2[i]?.imageUrl) {
                                eq = false
                            }
                        } else if (a.type == "filling" || a.type == "fillingImage") {
                            if (JSON.stringify(a.selected_answer) != JSON.stringify(ans2[i]?.selected_answer)) {
                                eq = false
                            }
                        } else {
                            if (a?.answer != ans2[i]?.answer) {
                                eq = false
                            }
                        }
                    })
                }
            } else {
                eq = ans1 == ans2
            }
            return eq;
        } catch (error) {
            Sentry.captureException(`498 Error in compareAnswer: ${error}`);
            return false;
        }
    }
    const removekAutoSubmission = () =>{
        try {
            updateOnInterval.cancel();
        } catch (error) {
            Sentry.captureException(`499 Error in removekAutoSubmission: ${error}`);
            console.log(error, "error in cancleing updateOnInterval ")
        }
    }


    const checkInApporiate = (answerText) => {
        const textAnswer = getTextFromHtml(answerText);
        const { isFound } = checkBadWords(textAnswer, null,true);
        if (isFound) {
          return true;
        }
        return false
    }

    const checkBadWordsInAnswer = (submissionAnswers = selections) => {
      try {
        if (userRol !== 'student') {
          return false;
        }
        const answersList = Array.isArray(submissionAnswers) ? submissionAnswers : [];
        for (let i = 0; i < data.questions.length; i += 1) {
          const questionData = data.questions[i];
          const answerData = answersList[i];
          const shouldValidate =
            questionData?.type === 'essay' ||
            questionData?.type === 'email' ||
            questionData?.type === 'audioEssay' ||
            (questionData?.type === 'picture' && questionData?.categoryType === 'Text') ||
            (questionData?.type === 'picture' && questionData?.categoryType === 'ImageAndText') ||
            (questionData?.type === 'photoCollage' && questionData?.categoryType?.includes('Text')) ||
            (questionData?.type === 'filling' && questionData?.response_type === 'input');
          if (!shouldValidate || !answerData) {
            continue;
          }
          let answerText = '';
          const isFillingWithText =
            questionData?.type === 'filling' && questionData?.response_type === 'input';
          if (isFillingWithText) {
            answerText = answerData?.selected_answer
              ? Object.values(answerData?.selected_answer)
                .flat()
                .map((obj) => obj?.answer)
                .join(' ')
              : '';
          } else if (
            questionData?.type === 'photoCollage' &&
            questionData?.categoryType?.includes('Text')
          ) {
            answerText = answerData?.answer_text;
          } else {
            answerText = answerData?.answer;
          }
          if (!answerText) {
            continue;
          }
          if (checkInApporiate(answerText)) {
            return true;
          }
        }
        return false;
      } catch (error) {
        console.log(error, 'error in checkBadWordsInAnswer');
        return false;
      }
    };

    const createFirstSubmission = useEffectEvent(() => {
        if(currentSubmission && Object.keys(currentSubmission).length > 0) return;
        updateAnswers(false, null, false, selections);
    });


    useEffect(() => {
        createFirstSubmission();
    }, [currentSubmission]);

    const updateAnswers = async (complete, finishAt, notRedirected, submission_value,with_time=false,is_auto_submit=false) => {
        // setAssignmentCreationLoading(true)
       const isBadWords = checkBadWordsInAnswer();
       if(isBadWords){
        return;
       }
        let is_auto = false;
        let is_with_time  = Boolean(with_time);
        if(submission_value){
            is_auto = true;
        }
        if(complete){
            finalSubmittedRef.current = true;
            setTrackingSessionEnded(true);
        }
        let submissiom_data = currentSubmission;
        if ((!submissiom_data && currentSubmissionRef.current && currentSubmissionRef.current.id) || (submission_value && currentSubmissionRef.current && currentSubmissionRef.current.id)) {
            submissiom_data = currentSubmissionRef.current;
            if (!complete) {
                complete = currentSubmissionRef.current.complete;
            }
        }
        let isLate = false
        let _timmer = timmer;
        setStepAlreadySet(true)
        const answers_to_submit = Array.isArray(submission_value)?submission_value:selections
        if(compareAnswer(submission_value,currentSubmissionRef.current?.answers)||(finalSubmittedRef.current&&!complete)){
            return
        }
        if (dueDate) {
            isLate = isBeforTime(dueDate, servertime, timezone);
        }
        if (complete && onFinish && typeof onFinish == "function") {
            onFinish();
        }
        if (complete && data?.id && userRol === 'student') {
            localStorage.removeItem(`finishLater_${data.id}`);
        }
        if (!submissiom_data && complete) {
            const { grade, manualGrading , face_grade } = await gradeQuiz() ?? {}
            setLoading(true);
            setAssignmentCreationLoading(true)
            let to_grade =  isCompleteInComplete ? '100' : grade;
            let to_face_grade = isCompleteInComplete ? max_point : face_grade;
            const submission_data = await dispatch(handleCreateSubmission({
                assignmentId: data.id,
                assignmentType: data.typeId,
                classId: currentClass.id,
                orgId: currentOrg?.id,
                userId: currentUser?.id,
                chapter: chapter,
                grade: to_grade,
                face_grade: to_face_grade,
                answers:  answers_to_submit,
                complete: complete,
                finishLater: finishAt >= 0 ? finishAt : null,
                submissions: 1,
                retakes: retakes,
                retaking: false,
                graded: !has_manual_grading,
                timmer: _timmer,
                isLate,
                manualGrading,
                assignment:data,
                is_auto,
                is_with_time,
                is_auto_submit,
                ai_grading_enabled:isAiPermissionEnabled,
                meta_data: userRol === 'student' ? assignmentTracking.getMetaData() : undefined,
            }))
            const grade_to_send =  isPointSystem?to_face_grade:to_grade
            await Promise.all([
                updateGradetoSchoology(grade_to_send, 0,manualGrading),
                updateGradeToCanvas(grade_to_send),
                updateGradetoGoogleClassRoom(grade_to_send)
            ])
            if(submission_data&&submission_data.id){
                if(isAiPermissionEnabled){
                // dispatch(handleAiFeedback(submission_data.id, data?.language_feedback));
                dispatch(handleAiAutoGradingSchedule(submission_data.id, data?.language_feedback));
                }
            }
            setLoading(false)
            setCompleted(true);
            setAssignmentCreationLoading(false)
            const notificationData = {
                id: v4(),
                classId: get(currentClass, 'id', ''),
                displayName: get(assignment, "displayName", get(data, "displayName", '')),
                senderId: get(currentUser, 'id', ''),
                receiversId: currentClassTeacher,
                modified: dayjs().toISOString(),
                data: {
                    chapter: chapter,
                    page: page,
                    id: get(data, 'id', ''),
                },
                message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Submit this Assignment`,
                type: 'update_activity',
                userSeen: []
            }
            //close previous feedback
            closeFeedback()
            await sendNotifications(notificationData);
            if (submission_data?.id) {
                await dispatch(handleRefreshUserSubmissionInClass({
                    userId: currentUser?.id,
                    classId: currentClass?.id,
                    submissionId: submission_data.id,
                }));
            }
            if (keepAssignmentPageAfterSubmitRef.current) {
                keepAssignmentPageAfterSubmitRef.current = false;
                navigateToAssignmentPage();
                return;
            }
            if (redirectTo) {
                navigate(redirectTo);
                return;
            }
            const urlstring = `${location.pathname}${location.search}`.replace(/quiz=[0-9a-zA-Z-]*/g, 'quiz=null').replace(/activity=[0-9a-zA-Z-]*/g, 'activity=null')
            setTimeout(() => navigate(urlstring), wait_timmer)
        } else if (!submissiom_data && !complete) {
            setAssignmentCreationLoading(true)
            let quizdata = {
                assignmentId: data.id,
                assignmentType: data.typeId,
                classId: currentClass.id,
                orgId: currentOrg?.id,
                userId: currentUser?.id,
                chapter: chapter,
                grade: isCompleteInComplete?'100':'',
                face_grade: isCompleteInComplete ? max_point : '',
                answers: answers_to_submit,
                complete:complete,
                submissions: 0,
                retakes: retakes,
                finishLater: finishAt >= 0 ? finishAt : null,
                graded: !has_manual_grading,
                retaking: true,
                feedback: '',
                timmer: _timmer,
                isLate,
                assignment:data,
                is_auto,
                is_with_time,
                is_auto_submit,
                ai_grading_enabled:isAiPermissionEnabled,
                meta_data: userRol === 'student' ? assignmentTracking.getMetaData() : undefined,
            }
            // const {isValid,reason}=validateData(quizdata,["assignmentId","assignmentType","classId","orgId","userId","chapter"])
            await dispatch(handleCreateSubmission(quizdata))
            setAssignmentCreationLoading(false)
        } else {
            if (complete && get(submissiom_data, 'returned', '') > 0) {
                finalSubmit(_timmer, notRedirected,  is_auto, is_with_time,is_auto_submit)
                const notificationData = {
                    id: v4(),
                    classId: get(currentClass, 'id', ''),
                    displayName: get(assignment, "displayName", get(data, "displayName", '')),
                    senderId: get(currentUser, 'id', ''),
                    receiversId: currentClassTeacher,
                    modified: dayjs().toISOString(),
                    data: {
                        chapter: chapter,
                        page: page,
                        id: get(data, 'id', ''),
                    },
                    message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Re-Submited this Assignment`,
                    type: 'update_activity',
                    userSeen: []
                }
                sendNotifications(notificationData);
            } else if(complete && get(submissiom_data, 'submissions', '') > 0){
                finalSubmit(_timmer, notRedirected,  is_auto, is_with_time,is_auto_submit)
                const notificationData = {
                    id: v4(),
                    classId: get(currentClass, 'id', ''),
                    displayName: get(assignment, "displayName", get(data, "displayName", '')),
                    senderId: get(currentUser, 'id', ''),
                    receiversId: currentClassTeacher,
                    modified: dayjs().toISOString(),
                    data: {
                        chapter: chapter,
                        page: page,
                        id: get(data, 'id', ''),
                    },
                    message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Retake this Assignment`,
                    type: 'update_activity',
                    userSeen: []
                }
                sendNotifications(notificationData);
            } else if (complete) {
                finalSubmit(_timmer, notRedirected,  is_auto, is_with_time,is_auto_submit)
                const notificationData = {
                    id: v4(),
                    classId: get(currentClass, 'id', ''),
                    displayName: get(assignment, "displayName", get(data, "displayName", '')),
                    senderId: get(currentUser, 'id', ''),
                    receiversId: currentClassTeacher,
                    modified: dayjs().toISOString(),
                    data: {
                        chapter: chapter,
                        page: page,
                        id: get(data, 'id', ''),
                    },
                    message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Submit this Assignment`,
                    type: 'update_activity',
                    userSeen: []
                }
                sendNotifications(notificationData);
            } else {
                setAssignmentCreationLoading(true)
                await dispatch(handleUpdateSubmission(
                    submissiom_data.id,
                    {
                        answers: answers_to_submit,
                        complete:complete,
                        grade: isCompleteInComplete?100:submissiom_data.grade,
                        face_grade:submissiom_data.face_grade,
                        submissions: submissiom_data.submissions,
                        retaking: true,
                        graded: !has_manual_grading,
                        feedback: '',
                        timmer: _timmer,
                        finishLater: finishAt >= 0 ? finishAt : null,
                        isLate,
                        assignment:data,
                        is_auto,
                        is_with_time,
                        is_auto_submit,
                        ai_grading_enabled:isAiPermissionEnabled,
                        meta_data: userRol === 'student' ? assignmentTracking.getMetaData() : undefined,
                    }
                ));
                setAssignmentCreationLoading(false)
            }
        }
        if(isCompleteInComplete){
            updateGradeToCanvas('complete')
        }
    };
    const finalSubmit = async (_timmer, notRedirected,  is_auto,is_with_time,is_auto_submit) => {
        onFinish && onFinish()
        if (isInSubmit) return;
        isInSubmit = true;
        let isLate = false
        if (dueDate) {
            isLate = isBeforTime(dueDate, servertime, timezone);
        }
        const sunmissions_ref = currentSubmission && currentSubmission.id ? currentSubmission : currentSubmissionRef.current
        let complete = true
        setLoading(true);
        const { grade, manualGrading , face_grade } = await gradeQuiz(complete, sunmissions_ref) ?? {}
        let submi = isNaN(sunmissions_ref?.submissions) ? 0 : parseInt(sunmissions_ref?.submissions, 10)
        ++submi;
        const v =  isPointSystem?face_grade:grade
        await Promise.all([
            updateGradetoSchoology(v, 0,manualGrading),
            updateGradeToCanvas(v),
            updateGradetoGoogleClassRoom(v)
        ])
        setAssignmentCreationLoading(true)
        await dispatch(handleUpdateSubmission(
            sunmissions_ref?.id,
            {
                answers: selections,
                complete: complete,
                grade: isCompleteInComplete?'100':grade,
                submissions: submi,
                retaking: false,
                graded: !has_manual_grading,
                feedback: '',
                timmer: 0,
                manualGrading,
                isLate,
                face_grade,
                assignment:data,
                is_auto,
                is_with_time,
                is_auto_submit,
                ai_grading_enabled:isAiPermissionEnabled,
                meta_data: userRol === 'student' ? assignmentTracking.getMetaData() : undefined,
            }
        ));
        
         // Call standard feedback API if questions have explanations (indicating standard exam)
         const hasExplanations = data?.questions?.some(question => question.explanation);
         if (hasExplanations && data?.type !== 'custom' && isStandardExam) {
             dispatch(handleAiStandardFeedback(currentSubmission.id, data?.language_feedback));
         }
        if(isAiPermissionEnabled){
            // dispatch(handleAiFeedback(sunmissions_ref.id, data?.language_feedback));
            dispatch(handleAiAutoGradingSchedule(sunmissions_ref.id, data?.language_feedback));
        }
        if (sunmissions_ref?.id) {
            await dispatch(handleRefreshUserSubmissionInClass({
                userId: currentUser?.id,
                classId: currentClass?.id,
                submissionId: sunmissions_ref.id,
            }));
        }
        setTimeout(() => { isInSubmit = null }, wait_timmer)
        setLoading(false)
        setCompleted(true);
        closeFeedback()
        if (keepAssignmentPageAfterSubmitRef.current) {
            keepAssignmentPageAfterSubmitRef.current = false;
            navigateToAssignmentPage();
            return;
        }
        if (redirectTo && !notRedirected) {
            navigate(redirectTo)
            return;
        }
        const urlstring = `${location.pathname}${location.search}`.replace(/quiz=[0-9a-zA-Z-]*/g, 'quiz=null').replace(/activity=[0-9a-zA-Z-]*/g, 'activity=null')
        setTimeout(() => navigate(urlstring), wait_timmer)
        setAssignmentCreationLoading(false)
    }
    const [subCheck, setSubCheck] = useState(false);
    const noAudiosRef = useRef(false)
    const subCheckRef = useRef(false)
    const submissionCheck = async () => {
        if (data?.questions && data?.questions[0]?.type !== 'audio' && data?.questions[0]?.type !== 'twoMinAudio') {
            subCheckRef.current = true
        } else if (noAudiosRef.current) {
            subCheckRef.current = false
        } else {
            subCheckRef.current = true
        }
    }

    submissionCheck();
    useEffect(() => {
        if (subCheckRef.current) {
            if (!subCheck)
                setSubCheck(true)
        } else if (noAudiosRef.current) {
            if (subCheck)
                setSubCheck(false)
        } else {
            setSubCheck(!subCheck)
        }
    }, [noAudiosRef.current, subCheckRef.current])
    useEffect(() => {
        const isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
        if (navigator.permissions && !isFirefox) {
            navigator.permissions.query(
                { name: 'microphone' }
            ).then(function (permissionStatus) {
                if (permissionStatus.state == "denied") {
                    noAudiosRef.current = true
                }
                permissionStatus.onchange = function () {
                    if (this.state == "denied") {
                        noAudiosRef.current = true
                    } else {
                        noAudiosRef.current = false
                    }

                }

            })
        }
        return () => {
            onFinish && onFinish()
        }
    }, [])
    useEffect(() => {
        if (setSubmitRef) {
            setSubmitRef(updateAnswers)
        }
    }, [setSubmitRef])

    const isContentEmpty = (htmlString) => {
        const textContent = htmlString.replace(/<[^>]*>/g, '').trim();
        return textContent === '';
      };


      
    const disabledCheck = useCallback((index) => {
        try {
            let question = data?.questions[index];
            const selectionAnswer = selections[index] ? selections[index] : undefined;
            if(selectionAnswer === undefined || !selectionAnswer || selectionAnswer?.length === 0 || Object.keys(selectionAnswer).length === 0){
                return true
            }
            if (selectionAnswer?.type === "photoCollage") {
            // Check if all images are filled
            const allImagesFilled = selectionAnswer?.answer?.every(
                item => typeof item.image === 'string' && item.image.trim() !== ""
            );
            
            // First check if we have a proper selectionAnswer object
            if (!selectionAnswer) {
                return true; // Missing answer
            }
            
            // Handle Text and Audio combined case
            if (question?.categoryType?.includes("Text") && question?.categoryType?.includes("Audio")) {
                const isTextEmpty = !selectionAnswer.answer_text || isContentEmpty(selectionAnswer.answer_text);
                const isAudioEmpty = !selectionAnswer.answer_audio || selectionAnswer.answer_audio.length === 0;
                
                return isTextEmpty || isAudioEmpty || !allImagesFilled;
            }
            
            // Handle Text-only case
            else if (question?.categoryType?.includes("Text")) {
                const isTextEmpty = !selectionAnswer.answer_text || isContentEmpty(selectionAnswer.answer_text);
                
                return isTextEmpty || !allImagesFilled;
            }
            
            // Handle Audio-only case
            else if (question?.categoryType?.includes("Audio")) {
                const isAudioEmpty = !selectionAnswer.answer_audio || selectionAnswer.answer_audio.length === 0;
                
                return isAudioEmpty || !allImagesFilled;
            }
            
            // If neither Text nor Audio is required, just check images
            return !allImagesFilled;
            }
        
            if (selectionAnswer?.type === "picture" && selectionAnswer?.categoryType === "ImageAndText") {
              const isImageEmpty = !selectionAnswer.imageUrl || selectionAnswer.imageUrl?.length === 0;
              const isAnswerEmpty = isContentEmpty(selectionAnswer?.answer) || selectionAnswer?.length === 0;
              return (isImageEmpty || isAnswerEmpty);
            }
          

            if (question.type === "picture" && question.categoryType === "Text") {
                const isAnswerEmpty = isContentEmpty(selectionAnswer?.answer) || !selectionAnswer?.answer || selectionAnswer?.length === 0 || !selectionAnswer || selectionAnswer === undefined;
                return (isAnswerEmpty);
            }

          if (question.type === "picture" && question.categoryType === "Image") {
              const isImageEmpty = !selectionAnswer.imageUrl || selectionAnswer.imageUrl?.length === 0;
              return isImageEmpty;
          }

          if (question.type === "audioToImage") {
              const isImageEmpty = !selectionAnswer.imageUrl || selectionAnswer.imageUrl?.length === 0;
              return isImageEmpty;
          }

          if(question.type === "match"){
            if(selections[index]?.match_data?.length !== question?.options?.length){
                return true;
            }
          }
          if(question?.type === "filling" || question?.type === "fillingImage" ){
            if (!selectionAnswer?.selected_answer) {
                return true;
            }
            return !isFillingQuestionFullyAnswered(question, selectionAnswer);
          }
          
          if (question?.type === 'essay'|| question?.type === 'email' || question?.type === 'audioEssay') {
            return textInputDisableCheck(index)
          }
          return false;
        } catch (error) {
            Sentry.captureException(`500 Error in disabledCheck: ${error}`);
        }
    }, [selections, data?.questions,step])
    // Build a safe character set from your arrays (avoids escaping issues)
    const SPANISH_CHAR_CLASS = (() => {
        const specials = [...SPANISH_ITEM_LOWER, ...SPANISH_ITEM_UPPER];
        // escape regex metacharacters if any appear
        const escaped = specials.map(ch => ch.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'));
        return escaped.join('');
    })();

    // Alphanumeric OR any of your spanish chars (áéíóúüñ ÁÉÍÓÚÜÑ ¿ ? ¡ !)
    const ALLOWED_PATTERN = new RegExp(`[A-Za-z0-9${SPANISH_CHAR_CLASS}]`);
    const textInputDisableCheck = useCallback((index) => {
        try {
            const answered = selections ? selections[index] : {};
            if (typeof answered?.answer !== 'string') return true;
            const cleanedAnswer = answered?.answer.replace(/<[^>]*>/g, '')
                .replace(/\s/g, '')
                .replace(/&[^;]+;/g, '')
                .replace(/[<>&]/g, '')
                .replace(/&[^;]+;/g, '')   // strip HTML entities
                .trim();
            // const hasAlphanumeric = /[a-zA-Z0-9]/.test(cleanedAnswer);
            const hasAllowed = ALLOWED_PATTERN.test(cleanedAnswer);
            return !hasAllowed;
        } catch (error) {
            Sentry.captureException(`501 Error in textInputDisableCheck: ${error}`);
            return true;
        }
    }, [selections]);
    const updateGradeToCanvas = async (_val) => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id) {
            await canvasSubmissionCreate()
            let assignmentId = assignment?.canvas_id ||  assignment?.data?.canvas_id
                await handleUpdateCanvasGrade(currentUser.canvas_id,{
                    "canvas_assignment_id": assignmentId,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":currentUser.canvas_id,
                    "grade": isCompleteInComplete?'complete': _val
                },currentUser.canvas_auth_id)
        }
    }
    const canvasSubmissionCreate = async () => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id) {
            let assignmentId = assignment?.canvas_id ||  assignment?.data?.canvas_id
            if(assignmentId){
                await handleCreateCanvaSubmissions(currentUser.canvas_id,{
                    "canvas_assignment_id": assignmentId,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":currentUser.canvas_id,
                },currentUser.canvas_auth_id)
            }
        }
    }
    const updateGradetoSchoology = async (_val, statusCode,manualGrading) => {
        if (currentClass && currentClass.sectionId && currentUser && currentUser.schoologyid&&assignment?.sAssignmentId) {
            await handleGradeToSchoology({
                sectionId:currentClass?.sectionId,schoologyid:currentUser.schoologyid , statusCode:statusCode, value:_val, studentSchoologyIds:[currentUser.schoologyid], sAssignmentId:assignment.sAssignmentId,
                manualGrading
            },true)
        }
    }
    const updateGradetoGoogleClassRoom = async (_val) => {
        if (currentClass && currentClass.googleId && currentUser && currentUser.googleId) {
            try {
                let assignmentId = assignment?.googleId || assignment?.data?.googleId
                if(assignmentId){
                    await handleUpdateGradeToGoogleClassRoom(currentUser.googleId, currentUser.googleId, currentClass.googleId, assignmentId, _val)
                }
            } catch (error) {
                Sentry.captureException(`502 Error in updateGradetoGoogleClassRoom: ${error}`);
            }
        }
    }
    const finishlaterClick = async () => {
        closeFeedback();
        const isBadWords = checkBadWordsInAnswer();
        if(isBadWords){
         return;
        }
        dispatch(updateUI({openEngageModalTeacher: {}}));
        closeExtensionActivity();
          setTextEditorData("");
        if (assignmentCreationLoading) return;
        if (timmer > 0) {
            showAlert('This functionality is blocked for time-based activities.', 'error');
        } else {
            const hasPreviousSubmission = currentSubmission && (
                currentSubmission.complete || 
                (Array.isArray(currentSubmission.pastSubmissions) && currentSubmission.pastSubmissions.length > 0)
            );
            if (data?.id && userRol === 'student') {
                if (hasPreviousSubmission) {
                    localStorage.removeItem(`finishLater_${data.id}`);
                } else {
                    localStorage.setItem(`finishLater_${data.id}`, 'true');
                }
            }
            if (userRol === 'student') {
                setTrackingSessionEnded(true);
                assignmentTracking.recordFinishLater();
                assignmentSessionReplay.recordFinishLater();
            }
            updateAnswers(false, step)
            onClose()
            setTimeout(() => navigateToAssignmentPage(), 0)
        }
        revokeStoryView()
        //Close the story widget on finish later
        const trafficData = trafficModal?.widget_menu ?? [];
        const existingWidget = find(trafficData, (item) => item?.menu === "assignment_story");
        if (existingWidget) {
            dispatch(revokeTrafficModal(existingWidget.id));
        }
        // updatePopUpAtOnce(false);
    }
    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
    const handleAddedLabel = (value) => {
        if (typeof value === 'string') {
            return value.replace(/^[a-f][).]\s*/, '');
        }
        return value;
    }
    const trenacriptAudio = (url) => {
        handleAudioTranscript(url)
    }

    const ShowAutoSaveLoader = () => {
      return (
        <div style={{fontSize: "10px"}}  class="auto-save-dots ml-8px">
          <label className="auto-saving-text ml-10px">{`(Saving`}</label>
          <LoaderContainer>
                <LoadingDiv>
                    <CircleDiv></CircleDiv>
                    <CircleDiv></CircleDiv>
                    <CircleDiv></CircleDiv>
                </LoadingDiv>
            </LoaderContainer>
          <div className="auto-saving-text">{`)`}</div>
        </div>
      );
    };


    const fetchStoryAI = async (type) => {
        console.log("fetchStoryAI triggered", { type, storyInstruction: data?.storyInstruction, userRol });
        // if (checkPopUpAtOnce() && type === "clickEvent") {
        //     console.log("fetchStoryAI blocked because another popup is open");
        //     return;
        // }
        // if(type === "clickEvent"){
        //     updatePopUpAtOnce(true);
        //     console.log("fetchStoryAI marked popup state as open");
        // }
      setStoryAILoader(true);
      let storyResult = null;
      
      if(Array.isArray(book_story) && book_story.length > 0){
        const has_soy_story = book_story.find((story) => story.id === data?.storyInstruction);
        if (has_soy_story && has_soy_story?.id) {
          storyResult = has_soy_story;
          console.log("fetchStoryAI found story in local store", storyResult);
        }
      }
      
      if (!storyResult) {
        console.log("fetchStoryAI fetching story by id", data?.storyInstruction);
        storyResult = await dispatch(
          handleListStoryById(data?.storyInstruction)
        );
        console.log("fetchStoryAI fetched story response", storyResult);
      }
      
      setStoryAILoader(false);
      
      if (storyResult && storyResult?.id) {
        if (userRol === 'student') {
          const trafficData = trafficModal?.widget_menu ?? [];
          const existingWidget = find(trafficData, (item) => item?.menu === "assignment_story");
          if (existingWidget) {
            console.log("fetchStoryAI removing existing assignment story widget", existingWidget);
            await dispatch(revokeTrafficModal(existingWidget.id));
            // updatePopUpAtOnce(false);
          }
          
          const widgetData = {
            id: `assignment_story_${Date.now()}_${Math.random()}`,
            view: true,
            menu: 'assignment_story',
            data: {
              storyData: storyResult
            }
          };
          console.log("fetchStoryAI opening assignment story widget", widgetData);
          await dispatch(invokeTrafficView(widgetData));
        } else {
          console.log("fetchStoryAI opening teacher story view", storyResult);
          invokeStoryView(storyResult, "story");
        }
      } else {
        console.log("fetchStoryAI did not get valid story data", storyResult);
      }
    };
    const fetchAiLevel = async (type) => {
        // if (checkPopUpAtOnce() && type === "clickEvent") {
        //     return;
        // }
        // if(type === "clickEvent"){
        //     updatePopUpAtOnce(true);
        // }
        setLevelAILoader(true);
        if (Array.isArray(book_artilce_level) && book_artilce_level.length > 0) {
            const has_level = book_artilce_level.find((level) => level.id === data?.article_level_id);
            if (has_level && has_level?.id) {
                invokeStoryView(has_level, "article_level");
                setLevelAILoader(false);
                return;
            }
        }
        const result = await handleGetArticleByid(data?.article_level_id);
        setLevelAILoader(false);
        if (result && result?.success) {
            invokeStoryView(result.data, "article_level");
        }
    };

    const ShowStoryBtn = () => {
        if(!storyResultMemo) return null;
        return (
            <AssignmentPlan onClick={() => fetchStoryAI("clickEvent")}>
                <AssignmentPlanInner>{storyAILoader ? <Loading size={16} white /> : 'View Story'}</AssignmentPlanInner>
            </AssignmentPlan>
        )
    }
    const ShowLevelButton = () => {
        return (
            <AssignmentPlan onClick={() => fetchAiLevel("clickEvent")}>
                <AssignmentPlanInner>{levelAILoader ? <Loading size={16} white /> : 'View Level'}</AssignmentPlanInner>
            </AssignmentPlan>
        )
    }
    const cleanString = (str) => (str || '').replace(/_/g, ' ').toLowerCase().trim();
    const onChangeHandler = (index, optId, value = "", selectedValueIndex, question, type) => {
        try{
            // Create deep copy of questions
        const updatedQuestions = JSON.parse(JSON.stringify(shuffledQuestions));
        const highlightedWords = updatedQuestions[index]?.highlightWords;
        
        let data = [...selections];
        let selectedAnswer;
        const expected_answer = updatedQuestions[index]?.highlightWords[optId][selectedValueIndex]?.text || ''
        const user_value = value || '';
        const is_answer = cleanString(expected_answer) === cleanString(user_value);
        // const is_answer = updatedQuestions[index]?.highlightWords[optId][selectedValueIndex]?.text === value ? true : false;

      
        // Determine if this is first selection or updating existing
        if (!selections[question]?.selected_answer || !Object.keys(selections[question]?.selected_answer).length) {
          selectedAnswer = highlightedWords.map(group =>
            group.map(() => ({
              answer: "",
              correct_answer: false
            }))
          );
          
          // Update specific answer
          selectedAnswer[optId][selectedValueIndex] = { answer: value, is_correct: is_answer };
          
          data[question] = {
            answer: "",
            type: type === 'fillingImage' ? "fillingImage" : "filling",
            selected_answer: selectedAnswer
          };
        } else {
          // Update existing answers
          const selectionSelectedAnswer = JSON.parse(JSON.stringify(selections[question]?.selected_answer || {}));
          selectedAnswer = [...(selectionSelectedAnswer[optId] || [])];
          selectedAnswer[selectedValueIndex] = { answer: value, is_correct: is_answer };
          
          data[question] = {
            ...data[question],
            answer: "",
            type: type === 'fillingImage' ? "fillingImage" : "filling",
            selected_answer: { ...selectionSelectedAnswer, [optId]: selectedAnswer }
          };
        }

        // Update state once
        const updateState = () => {
          setQuestion(question);
          setSelectedQ(true);
          setSelections(data);
          updateAnswers(false, null, false, data);
          forceUpdate();
        };
      
        updateState();

        }catch(error){
            Sentry.captureException(`503 Error in onChangeHandler: ${error}`);
            console.log(error);
        }
        
      };

    const onWidgetClick = async () => {
      try {
        if (loadingWidget) return;
        setLoadingWidget(true);
        
        const response = await dispatch(
          handleGetSumissionById({
            userId: currentUser?.id,
            classId: currentClass?.id,
            submissionId: currentSubmission?.id,
          }),
        );
        let submissionData = [];
        if(!response){
            showAlert('No submission found', 'error');
            return;
        }

        if(view_result && response?.pastSubmissions?.length > 0){
            response.is_current = true;
            submissionData = [...response?.pastSubmissions, ...[response]];
        }else {
            response.is_current = true;
            submissionData = [...[response]];
        }
     
        const widgetData = {
          id: 25,
          view: true,
          menu: 'previous_Feedback',
          pas_submission: submissionData,
          currentSubmission: response,
          data: data,
        };
        await dispatch(invokeTrafficView(widgetData));
        setLoadingWidget(false);
      } catch (error) {
        setLoadingWidget(false);
        logToSentry({
          message: 'Error in onWidgetClick',
          error: error,
          module: 'ASSIGNMENT',
          operation: 'onWidgetClick'
        });
      } finally {
        setLoadingWidget(false);
      }
    };

  const onSubmitCall = (index) => {
    const isBadWords = checkBadWordsInAnswer(selections);
    if(isBadWords){
     return;
    }
    const isFinalQuestion = data?.questions.length === index + 1;
    if (userRol === 'student' && isFinalQuestion) {
        keepAssignmentPageAfterSubmitRef.current = true;
    }
    dispatch(updateUI({openEngageModalTeacher: {}}));
    closeExtensionActivity();
    setTextEditorData("");
    clearTimeout(debounceAssignmentSubmission);
    debounceAssignmentSubmission = setTimeout(async () => {
        if (assignmentCreationLoading) return;

        if (isFinalQuestion) {
            if (userRol === 'student') {
                await updateAnswers(true);
                removekAutoSubmission();
            }
            revokeStoryView();
        } else {
            if (userRol === 'student') {
                updateAnswers(false);
                removekAutoSubmission();
            }
            setStep(step + 1);
            if (data?.questions.length === index + 1) {
                onClose();
            }
        }
    }, 300);
};


const handleCollageChange = (value, key = null, frameId = null,collageFrame,index) => {
    try {
      const currentQuestion = shuffledQuestions[step];
      const actualIndex = currentQuestion?.oldIndex !== undefined ? currentQuestion.oldIndex : step;
      setQuestion(actualIndex);
      setSelectedQ(true);
      
      const updatedSelections = [...selections];
      
      if (!updatedSelections[actualIndex]) {
        updatedSelections[actualIndex] = { type: "photoCollage" };
      }
      
      if (frameId !== null) {
        const answersCollage = updatedSelections[actualIndex]?.answer || collageFrame;
        const updatedCollage = answersCollage.map(element => {
          if (element?.id === frameId) {
            return { ...element, image: value };
          }
          return element;
        });
        
        updatedSelections[actualIndex] = {
          ...updatedSelections[actualIndex],
          answer: updatedCollage,
          type: "photoCollage"
        };
      } 
      else if (key !== null) {
        updatedSelections[actualIndex] = {
          ...updatedSelections[actualIndex],
          [key]: value,
          type: "photoCollage"
        };
      }
      
      setSelections(updatedSelections);
      updateAnswers(false, null, false, updatedSelections);
      forceUpdate();
    } catch (error) {
        Sentry.captureException(`504 Error in handleCollageChange: ${error}`);
      console.log(error);
    }
  };

  useEffect(() => {
    try {
      const currentQuestion = shuffledQuestions[step];
      if (textEditorData?.length > 0 && currentQuestion?.type === "photoCollage" && currentQuestion?.categoryType?.includes("Text")) {
        const actualIndex = currentQuestion?.oldIndex !== undefined ? currentQuestion.oldIndex : step;
        const updatedSelections = [...selections];
        updatedSelections[actualIndex] = {
          ...updatedSelections[actualIndex],
          answer_text: textEditorData,
          type: "photoCollage"
        };
        setSelections(updatedSelections);
        setQuestion(actualIndex);

        updateAnswers(false, null, false, updatedSelections);
        forceUpdate();
      }
    } catch (error) {
        Sentry.captureException(`505 Error in useEffect: ${error}`);
      console.log(error);
    }
  }, [textEditorData,step]);


    const handleNextQuestion = () => {
        const isBadWords = checkBadWordsInAnswer();
        if(isBadWords){
         return;
        }
        setTextEditorData("");
        if (assignmentCreationLoading) return;
        if (userRol === 'student') {
            updateAnswers(false);
            removekAutoSubmission();
        }
        disableGroupAudioAutoplayOnceRef.current = true;
        setShouldAutoPlayGroupAudio(false);
        setStep((prev) => prev + 1);
    };

    const handlePreviousQuestion = () => {
        setTextEditorData("");
        disableGroupAudioAutoplayOnceRef.current = true;
        setShouldAutoPlayGroupAudio(false);
        setStep((prev) => prev - 1);
    };

    const onReturnToActivityCreation = () => {
        const activityId = data?.typeId === 'quiz' ? null : (data?.id);
        const quizId = data?.typeId === 'quiz' ? (data?.id) : null;
        const fromPage = pageSelectionFrom
        if (currentPage != assignmentPage) {
            onNavigateToPage(assignmentPage, activityId, quizId);
        } else {
            onNavigateToPage(fromPage, activityId, quizId);
        }
    }

    const getReadNavigationLabel = () => {
        if (currentPage == assignmentPage) {
            return 'Back to Reading Page';
        } else {
            return 'Go Back';
        }
    }

    return (
        <SentryWrap>
        <Wrapper className='ebookInsWrap' data-owe-assignment-session>
            {userRol === 'student' && (
              <WidgetsAssignmentStory 
                currentClass={currentClass} 
                onClose={() => {
                //   updatePopUpAtOnce(false);
                }}
              />
            )}
            <Modal
                open={showRecordingAlert}
                onClose={() => setShowRecordingAlert(false)}
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)'
                }}
            >
                <Box
                    sx={{
                        width: '90%',
                        maxWidth: 500,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="h6" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
                        Submission in Progress
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                         Submission is in progress. You cannot navigate away from this page.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setShowRecordingAlert(false)}
                        sx={{ minWidth: 100 }}
                    >
                        OK
                    </Button>
                </Box>
            </Modal>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={finishlaterAlert.open}
                autoHideDuration={3000}
                onClose={() => { setFinishLaterAlert({ open: false, message: '' }) }}>
                <Alert onClose={() => { setFinishLaterAlert({ open: false, message: '' }) }} severity="error">
                    <strong>ALERT:</strong> {finishlaterAlert.message}
                </Alert>
            </Snackbar>
            <Modal
                open={pageSelectionModal.open}
                onClose={() => pageSelectionModal.isInRange && setPageSelectionModal(prev => ({ ...prev, open: false }))}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 1,
                    minWidth: 320,
                    maxWidth: 500
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="subtitle1" sx={{ mb: 2 }}>Read Lesson</Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isSpanish}
                                    onChange={(e) => setIsSpanish(e.target.checked)}
                                    size="small"
                                />
                            }
                            label={isSpanish ? "English" : "Spanish"}
                        />
                    </Box>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        {pageSelectionModal.fromPage === pageSelectionModal.toPage
                          ? (isSpanish
                              ? `¡Puedes leer la página ${getNumberMaskForAll(pageSelectionModal.fromPage)} para responder a la actividad!`
                              : `You can read page ${getNumberMaskForAll(pageSelectionModal.fromPage)} to answer the activity!`)
                          : (isSpanish
                              ? `Puedes leer páginas desde la página ${getNumberMaskForAll(pageSelectionModal.fromPage)} hasta la página ${getNumberMaskForAll(pageSelectionModal.toPage)} para responder la actividad!`
                              : `You can read pages from page ${getNumberMaskForAll(pageSelectionModal.fromPage)} to page ${getNumberMaskForAll(pageSelectionModal.toPage)} to answer the activity!`)
                        }
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                    {!isOnSamePage && !(Number(pageSelectionFrom) === Number(assignmentPage) && Number(pageSelectionFrom) === Number(currentPage)) ? <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                setPageSelectionModal({ open: false, fromPage: null, toPage: null, isInRange: true });
                                const goBack = typeof onReturnToActivityCreation === 'function' ? onReturnToActivityCreation : onClose;
                                if (typeof goBack === 'function') goBack();
                            }}
                        >
                            {getReadNavigationLabel()}
                            {/* {isSpanish ? 'Volver a la página de creación de la actividad' : 'Return to activity creation page'} */}
                        </Button>:<span></span>}
                        <Button variant="contained" color="primary" onClick={() => setPageSelectionModal({ open: false, fromPage: null, toPage: null, isInRange: true })}>
                            OK
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Container active={step > -1}>
                <Section>
                    <Row> 
                        <SectionHeader id="instructionsScroll">
                          Instructions
                          {pageInteractions?.length === 0 && (
                          <TimmerWrapper>
                            {timeInt !== 0 && currentUser?.role == 'student' ? timeInt : ''}
                          </TimmerWrapper>
                          )}
                        </SectionHeader>
                    </Row>
                    {/* {pageInteractions?.length > 0 && (
                        <Section className="addAudio" style={{ marginBottom: 24 }}>
                            {map(pageInteractions, action => (
                                <Interaction key={action.id} data={action} />
                            ))}
                        </Section>
                    )}  */}
                    {pageInteractions?.length > 0 && (
                          <TimmerWrappersection>
                            {timeInt !== 0 && currentUser?.role == 'student' ? timeInt : ''}
                          </TimmerWrappersection>
                    )}                   
                    <Row align="middle" gutter={[0, 16]}>
                        {/* <Col span={14}> */}
                            <AssignmentTitle className="breakTheSentence">{get(assignment, "displayName", get(data, "displayName", ''))}</AssignmentTitle>
                        {/* </Col> */}
                    </Row>
                    {showCountdownTimer && currentUser?.role === 'student' && (get(assignment, "dueDate") || (get(assignment, "lateDate") && !shouldSkipLateDateForDiffStudent(assignment, currentUser, currentClass))) && (
                        <div className="cardDetail">
                          <div className='cardDetailInr'>
                             <p>Time left to submit:</p>
                           </div>
                            <CountdownTimer 
                                dueDate={get(assignment, "dueDate")} 
                                lateDate={shouldSkipLateDateForDiffStudent(assignment, currentUser, currentClass) ? null : get(assignment, "lateDate")}
                                onTimeUp={() => {
                                setShowCountdownTimer(false);
                                if (assignment?.data?.id) {
                                    localStorage.removeItem(`finishLater_${assignment.data.id}`);
                                }
                                }}
                            />
                        </div>
                    )}
                    {data?.description && (
                        <Row gutter={[0, 24]}>
                            <Col span={24}>
                                <AssignmentDescription>{data?.description}</AssignmentDescription>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col span={24}>
                            <BarContainer>
                                {map(get(data, "questions", []), (x, index) => (
                                    <Bar key={index} complete={step > index - 1} />
                                ))}
                            </BarContainer>
                        </Col>
                    </Row>
                </Section>
            </Container>
            <div className='w-full flex items-center flex-wrap'>
                <Detail>Question {step + 1} of {data?.questions.length}
                </Detail>
                {is_extension_activity && (
                  <AssignmentPlan onClick={() => getCurrentExtensionActivityData()}>  <AssignmentPlanInner>{'View External Activity'}</AssignmentPlanInner></AssignmentPlan>
                )}
                
                <AssignmentPlan onClick={() => { onWidgetClick() }}>
                    <AssignmentPlanInner>{loadingWidget && <Loading size={16} white /> }Submission Feedback</AssignmentPlanInner>
                </AssignmentPlan>
                {pageSelectionFrom != null && pageSelectionTo != null &&
                    <AssignmentPlan onClick={() => { setPageSelectionModal({ open: true, fromPage: pageSelectionFrom, toPage: pageSelectionTo, isInRange: true }) }}>
                        <AssignmentPlanInner>Read Lesson</AssignmentPlanInner>
                    </AssignmentPlan>
                }
                {data?.storyInstruction && <ShowStoryBtn />}
                {data?.article_level_id ? <ShowLevelButton /> : null}
                {assignmentCreationLoading && <ShowAutoSaveLoader />}
            </div>
            {currentGroupAudio?.audio && (() => {
                const groupAudioKey = `group-${currentGroupAudio.instanceKey ?? currentGroupAudio.groupKey}`;
                if (!audioPlayersRef.current.has(groupAudioKey)) {
                    audioPlayersRef.current.set(groupAudioKey, { current: null, hasAutoPlayed: false });
                }
                const groupAudioRef = audioPlayersRef.current.get(groupAudioKey);
                return (
                        <ReactPlayer
                            ref={(ref) => {
                                groupAudioRef.current = ref;
                            }}
                            key={currentGroupAudio.instanceKey ?? currentGroupAudio.groupKey}
                            url={currentGroupAudio.audio}
                            height="40px"
                            width="100%"
                            controls
                            playsinline
                            onReady={() => {
                                if (shouldAutoPlayGroupAudio && groupAudioRef.current && !groupAudioRef.hasAutoPlayed) {
                                    setTimeout(() => {
                                        try {
                                            const internalPlayer = groupAudioRef.current.getInternalPlayer();
                                            if (internalPlayer && internalPlayer.paused) {
                                                pauseAllOtherAudioPlayers(groupAudioRef);
                                                internalPlayer.play();
                                                groupAudioRef.hasAutoPlayed = true;
                                                setShouldAutoPlayGroupAudio(false);
                                            }
                                        } catch (error) {
                                        }
                                    }, 300);
                                }
                            }}
                            onPlay={() => {
                                setShouldAutoPlayGroupAudio(false);
                                pauseAllOtherAudioPlayers(groupAudioRef);
                            }}
                            onPause={() => {
                                setShouldAutoPlayGroupAudio(false);
                            }}
                            style={{
                                margin: '16px 0px',
                            }}
                            config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
                        />
                );
            })()}
            {map(shuffledQuestions, (question, index) => {
                let actualIndex = 0;
                if(question?.type === "photoCollage"){
                    actualIndex = question?.oldIndex !== undefined && question?.oldIndex !== null ? question.oldIndex : index;
                }
                else{
                    actualIndex = question.oldIndex||index;
                }
                const currentAnswer = Array.isArray(selections) ? selections[actualIndex] : {} || {};
                if (!question || step >= data?.questions.length) {
                    if (step + 1 < data.questions.length) {
                        setStep(step + 1)
                    } else {
                        setStep(0)
                    }
                    return;
                }
                return (
                    <RelativeContainer key={index}>
                        {step === index && <QuestionContainer key={question.id} active={step === index} className='1212 QuestionContainerCstm'>
                        <ModalMenu type='imageModal' image={question?.pictures} open={openImageViewModal} close={()=> setOpenImageViewModal(false)} />
                            {!isQuestionEmpty(question.question) && (
                                <Question className="breakTheSentence" dangerouslySetInnerHTML={{ __html: question.question || '' }} />
                            )}
                            <Content ref={assessmentRefs}>
                                {question?.standard_story && (
                                    <div style={{ marginBottom: '10px', fontSize: '13px', fontWeight: '600' }}>
                                        Standard Story: {question.standard_story}
                                    </div>
                                )}
                                {question.type === 'email' && (
                                    <Row gutter={[0, 24]}>
                                        <Col span={24}>
                                            <TextEditor
                                                handleChange={data => handleChange(data, 'email', question?.oldIndex)}
                                                value={!!selections[question?.oldIndex]?.answer ? selections[question?.oldIndex]?.answer : ""}
                                            />
                                        </Col>
                                    </Row>
                                )}
                                {question.type === 'essay' && (
                                    <Row gutter={[0, 24]}>
                                        <Col span={24}>
                                            <TextEditor
                                                autoFocus={false}
                                                handleChange={data => handleChange(data, 'essay', question?.oldIndex)}
                                                value={!!selections[question?.oldIndex]?.answer ? selections[question?.oldIndex]?.answer : ""}
                                            />
                                        </Col>
                                    </Row>
                                )}
                                {question.type === 'multipleChoice' && (
                                    <>
                                        {map(get(question, "options", []), (option, i) => {
                                            if (!option || !option.value) return null;
                                            return (
                                                <Row key={i} style={{ marginBottom: '8px', display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                    <OptionLabel style={{ marginRight: '10px' }}>{OPTION_LABEL[i]}</OptionLabel>
                                                    <Option selected={selections[question?.oldIndex] && selections[question?.oldIndex]?.answer === `${option?.oldIndex}`} onClick={(e) => {
                                                        e.preventDefault()
                                                        handleSelect(question?.oldIndex, `${option?.oldIndex}`, 'string', question)
                                                    }}>{handleAddedLabel(option?.value)}</Option>
                                                </Row>
                                            )
                                        })}
                                    </>
                                )}
                                {question.type === 'multipleResponse' && (
                                    <>
                                        {map(get(question, "options", []), (option, i) => {
                                            if (!option || !option.value) return null;
                                            return (
                                                <Row key={i} style={{ marginBottom: '8px', display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                    <span style={{width:'20px'}} >{OPTION_LABEL[i]}</span>
                                                    <Option 
                                                        selected={selections[question?.oldIndex] && 
                                                                 Array.isArray(selections[question?.oldIndex].answer) && 
                                                                 selections[question?.oldIndex].answer.includes(`${option?.oldIndex}`)} 
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            const currentAnswers = selections[question?.oldIndex] && Array.isArray(selections[question?.oldIndex].answer) 
                                                                ? [...selections[question?.oldIndex].answer] 
                                                                : [];
                                                            const answerIndex = currentAnswers.indexOf(`${option?.oldIndex}`);
                                                            if (answerIndex > -1) {
                                                                currentAnswers.splice(answerIndex, 1);
                                                            } else {
                                                                currentAnswers.push(`${option?.oldIndex}`);
                                                            }
                                                            handleSelect(question?.oldIndex, currentAnswers, 'array', question)
                                                        }}
                                                    >
                                                        {handleAddedLabel(option?.value)}
                                                    </Option>
                                                </Row>
                                            )
                                        })}
                                    </>
                                )}
                                {question.type === 'match' && (
                                    <>
                                        {/* Render each left-side item with a corresponding dropdown for right-side matches */}
                                        <StudentMatch
                                            question={question}
                                            selectedAnswer={selections[question?.oldIndex]}
                                            onClick={(value) => {
                                                handleSelectMatch(question?.oldIndex, '', question?.type, value)
                                            }}
                                        />
                                    </>
                                )}
                                {question.type === 'bingo' && (
                                    <>
                                        {/* Render each left-side item with a corresponding dropdown for right-side matches */}
                                        <BingoStudentContent
                                            question={question}
                                            selectedAnswer={selections[question?.oldIndex]}
                                            onClick={(value) => {
                                                handleSelectMatch(question?.oldIndex, '', question?.type, value)
                                            }}
                                        />
                                    </>
                                )}
                                {question.type === 'audio' && (
                                    <>
                                    {question?.audio && (() => {
                                        const audioKey = `audio-${question?.oldIndex || index}`;
                                        if (!audioPlayersRef.current.has(audioKey)) {
                                            audioPlayersRef.current.set(audioKey, { current: null });
                                        }
                                        const audioRef = audioPlayersRef.current.get(audioKey);
                                        return (
                                            <ReactPlayer
                                                ref={(ref) => {
                                                    audioRef.current = ref;
                                                }}
                                                url={question?.audio}
                                                height="40px"
                                                width="100%"
                                                controls
                                                playsinline
                                                onPlay={() => {
                                                    pauseAllOtherAudioPlayers(audioRef);
                                                }}
                                                onPause={() => {

                                                }}
                                                onEnded={() => { }}
                                                style={{
                                                    margin: '16px 0px',
                                                }}
                                                config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
                                            />
                                        );
                                    })()}
                                        <AudioRecorder
                                            ref={audioRef}
                                            maxTime={question?.duration || 20}
                                            handleAudio={url =>{ 
                                                handleSelect(question?.oldIndex, url, 'audio')
                                                trenacriptAudio(url)
                                            }}
                                            index={index}
                                            currentSubmission={currentSubmission}
                                            refresh={() => navigate(-1)}
                                            source={currentAnswer?.answer || ""}
                                            setButtonDisabled={setButtonDisabled}
                                        />
                                    </>
                                )}
                                {question.type === 'audioEssay' && (
                                    <>
                                        {!question.groupKey && question.audio && (() => {
                                            const audioKey = `audioEssay-${question?.oldIndex || index}`;
                                            if (!audioPlayersRef.current.has(audioKey)) {
                                                audioPlayersRef.current.set(audioKey, { current: null });
                                            }
                                            const audioRef = audioPlayersRef.current.get(audioKey);
                                            return (
                                                <ReactPlayer
                                                    ref={(ref) => {
                                                        audioRef.current = ref;
                                                    }}
                                                    url={question.audio}
                                                    height="40px"
                                                    width="100%"
                                                    controls
                                                    playsinline
                                                    onPlay={() => {
                                                        pauseAllOtherAudioPlayers(audioRef);
                                                    }}
                                                    style={{ marginBottom: '8px' }}
                                                    config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
                                                />
                                            );
                                        })()}
                                        <Row gutter={[0, 24]}>
                                            <Col span={24}>
                                                <TextEditor
                                                    key={`audioEssay-editor-${question?.oldIndex}`}
                                                    handleChange={data => handleChange(data, 'audioEssay', question?.oldIndex)}
                                                    value={!!selections[question?.oldIndex]?.answer ? selections[question?.oldIndex]?.answer : ""}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {question.type === 'audioTrueFalse' && (
                                    <>
                                        {question.audio && (() => {
                                            const audioKey = `audioTrueFalse-${question?.oldIndex || index}`;
                                            if (!audioPlayersRef.current.has(audioKey)) {
                                                audioPlayersRef.current.set(audioKey, { current: null });
                                            }
                                            const audioRef = audioPlayersRef.current.get(audioKey);
                                            return (
                                                <ReactPlayer
                                                    ref={(ref) => {
                                                        audioRef.current = ref;
                                                    }}
                                                    url={question.audio}
                                                    height="40px"
                                                    width="100%"
                                                    controls
                                                    playsinline
                                                    onPlay={() => {
                                                        pauseAllOtherAudioPlayers(audioRef);
                                                    }}
                                                    style={{
                                                        margin: '16px 0px',
                                                    }}
                                                    config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
                                                />
                                            );
                                        })()}
                                         {map(get(question, "options", []), (option, i) => {
                                            if (!option || !option.value) return null;
                                            return (
                                                <Row key={i} style={{ marginBottom: '8px' ,  display: "flex", flexDirection: "row", alignItems: "center"  }}>
                                                     <span style={{ marginRight: '5px' }}>{OPTION_LABEL[i]}</span>
                                                    <Option selected={selections[question?.oldIndex] && selections[question?.oldIndex]?.answer === `${option?.oldIndex}`} onClick={(e) => {
                                                        e.preventDefault()
                                                        handleSelect(question?.oldIndex, `${option?.oldIndex}`, 'string', selections)
                                                    }}>{handleAddedLabel(option?.value)}</Option>
                                                </Row>
                                            )
                                        })}
                                    </>
                                )}
                                {question.type === 'audioToImage' && (
                                    <>
                                        {question.audio && (() => {
                                            const audioKey = `audioToImage-${question?.oldIndex || index}`;
                                            if (!audioPlayersRef.current.has(audioKey)) {
                                                audioPlayersRef.current.set(audioKey, { current: null });
                                            }
                                            const audioRef = audioPlayersRef.current.get(audioKey);
                                            return (
                                                <ReactPlayer
                                                    ref={(ref) => {
                                                        audioRef.current = ref;
                                                    }}
                                                    url={question.audio}
                                                    height="40px"
                                                    width="100%"
                                                    controls
                                                    playsinline
                                                    onPlay={() => {
                                                        pauseAllOtherAudioPlayers(audioRef);
                                                    }}
                                                    style={{
                                                        margin: '16px 0px',
                                                    }}
                                                    config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
                                                />
                                            );
                                        })()}
                                        <Row gutter={[0, 24]} style={{ marginTop: 16 }}>
                                            <Col span={24}>
                                                    <StudentPictureAssignment  
                                                       states={{question,selections,isTablate}} 
                                                       funcObj={{handleImageSelect,setOpenImageViewModal,trenacriptAudio,setButtonDisabled,handleAdditionalImages}}
                                                       isNewSubmission={!currentSubmission || (currentSubmission && !currentSubmission.complete && (!currentSubmission.pastSubmissions || currentSubmission.pastSubmissions.length === 0))}
                                                    />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {question.type === 'audioMultipleChoice' && (
                                    <>
                                         {map(get(question, "options", []), (option, i) => {
                                            if (!option || !option.value) return null;
                                            return (
                                                <Row key={i} style={{ marginBottom: '8px' ,  display: "flex", flexDirection: "row", alignItems: "center"  }}>
                                                     <span style={{ marginRight: '5px' }}>{OPTION_LABEL[i]}</span>
                                                    <Option selected={selections[question?.oldIndex] && selections[question?.oldIndex]?.answer === `${option?.oldIndex}`} onClick={(e) => {
                                                        e.preventDefault()
                                                        handleSelect(question?.oldIndex, `${option?.oldIndex}`, 'string', selections)
                                                    }}>{handleAddedLabel(option?.value)}</Option>
                                                </Row>
                                            )
                                        })}
                                    </>
                                )}
                                {question.type === 'video' && (
                                    <>
                                        {question.video && (
                                            <HlsVideoPlayer
                                                src={question.video}
                                                onPlay={() => {
                                                    // Handle play event if needed
                                                }}
                                                onPause={() => {
                                                    // Handle pause event if needed
                                                }}
                                                onEnded={() => {
                                                    // Handle video end event if needed
                                                }}
                                                style={{ marginBottom: '8px' }}
                                            />
                                        )}

                                        <VideoRecorder
                                            ref={videoRef} // Reference for accessing internal methods if needed
                                            maxTime={question.duration || 60} // Duration for video recording
                                            handleVideo={(url) =>{
                                                handleSelect(question?.oldIndex, url, 'video')
                                                if (url) {
                                                    handleAudioTranscript(url)
                                                }
                                            }} // Callback for video URL
                                            index={index} // Index of the question
                                            currentSubmission={currentSubmission} // Current submission data (if any)
                                            refresh={() => navigate(-1)} // Optional refresh logic
                                            student={true}
                                            videoSource={currentAnswer?.answer} // Preloaded video source if applicable
                                            hasSaveButton // Display save button for saving the recorded video
                                            message={`Record a video for your response`} // Instructional message for the user
                                            setButtonDisabled={setButtonDisabled}
                                        />
                                    </>
                                )}

                                {(question.type === 'filling' || question.type === 'fillingImage') && (
                                    <div>
                                        {map(get(question, "options", [""]), (option, optId) => {
                                            const totalBlanksAllKeys = (question?.highlightWords || []).reduce((sum, keyHighlights) => sum + (Array.isArray(keyHighlights) ? keyHighlights.length : 0), 0);
                                            const selectedAnswerGroups = Array.isArray(selections[question?.oldIndex]?.selected_answer)
                                                ? selections[question?.oldIndex]?.selected_answer
                                                : Object.values(selections[question?.oldIndex]?.selected_answer || {});
                                            const answeredAllKeys = selectedAnswerGroups.reduce((sum, selectedByKey) => {
                                                if (!Array.isArray(selectedByKey)) return sum;
                                                return sum + selectedByKey.filter((item) => item?.answer).length;
                                            }, 0);
                                            return (
                                            <div className='relative mb-20px'>
                                                <h3 className='question-fill-in-blanks'>{`Question ${optId + 1}.`}</h3>
                                                {question.type === 'fillingImage' || question.fillingType === "Image" && question?.filling_image[optId]?.url && (
                                                    <>
                                                   <ModalMenu 
                                                    type="imageModal"
                                                    image={question?.filling_image && question?.filling_image[optId]?.url}
                                                    open={(openImageFillBlanks?.open && openImageFillBlanks?.questionIndex === index && openImageFillBlanks?.optionIdx === optId) || false}
                                                    close={() => setImageFillBlanks({})}  />
                                                    <img
                                                        src={question?.filling_image && question?.filling_image[optId]?.url}
                                                        alt={`filling ${optId}`}
                                                        draggable={false}
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            borderRadius: "8px",
                                                            marginTop: "10px"
                                                        }}
                                                        onClick={() => setImageFillBlanks({
                                                            open: true,
                                                            questionIndex: index,
                                                            optionIdx: optId,
                                                        })}
                                                    />
                                                    </>
                                                )}
                                                {question.fillingType === 'Audio' && (
                                                    <>
                                                    {(question?.filling_image && question?.filling_image[optId]?.url) && (() => {
                                                        const audioKey = `filling-${question?.oldIndex || index}-${optId}`;
                                                        if (!audioPlayersRef.current.has(audioKey)) {
                                                            audioPlayersRef.current.set(audioKey, { current: null });
                                                        }
                                                        const audioRef = audioPlayersRef.current.get(audioKey);
                                                        return (
                                                            <ReactPlayer
                                                                ref={(ref) => {
                                                                    audioRef.current = ref;
                                                                }}
                                                                url={question?.filling_image && question?.filling_image[optId]?.url}
                                                                height="40px"
                                                                width="100%"
                                                                controls
                                                                playsinline
                                                                onPlay={() => {
                                                                    pauseAllOtherAudioPlayers(audioRef);
                                                                }}
                                                                style={{ marginBottom: '8px', marginTop: '10px' }}
                                                                config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
                                                            />
                                                        );
                                                    })()}
                                                    </>
                                                )}
                                                <StudentFillInTheBlanks
                                                    onChangeHandler={(value, selectedIndex) => {
                                                        onChangeHandler(index, optId, value, selectedIndex, question?.oldIndex, question?.type)
                                                    }}
                                                    question={question}
                                                    text={option?.value}
                                                    highlights={question.highlightWords[optId]}
                                                    answerOption={question?.answerSelected && question.answerSelected[optId] || []}
                                                    selected_answer={selections[question?.oldIndex]?.selected_answer && selections[question?.oldIndex]?.selected_answer[optId]}
                                                    response_type={question?.response_type}
                                                    showProgress={optId === 0}
                                                    progressTotalBlanks={totalBlanksAllKeys}
                                                    progressAnsweredCount={answeredAllKeys}
                                                />
                                            </div>
                                        )})}
                                    </div>
        
                                )}

                                {question.type === "photoCollage" && (
                                    <>
                                    <AssignmentPhotoCollage
                                        states={{
                                        isPreview: false,
                                        selectData: false,
                                        index: step,
                                        question: question,
                                        frameCollage: currentAnswer?.answer
                                            ? currentAnswer?.answer
                                            : question.collageFrame,
                                        collageLength: question.collageLength,
                                        }}
                                        funcObj={{ handleCollageChange }}
                                    />

                                    <div className="mt-10px mb-10px">
                                        <div>{question?.type_question_desc}</div>
                                    </div>

                                    {question?.categoryType?.includes("Text") && (
                                        <TextEditor
                                        key={`photoCollage-editor-${question?.oldIndex}`}
                                        handleChange={(data) => {
                                            setTextEditorData(data);
                                        }
                                           
                                        }
                                        value={
                                            !!selections[question?.oldIndex]?.answer_text
                                            ? selections[question?.oldIndex]?.answer_text
                                            : ""
                                        }
                                        />
                                    )}

                                    {question?.categoryType?.includes("Audio") && (
                                        <AudioRecorder
                                        maxTime={question?.duration || 120}
                                        handleAudio={(url) => {
                                            handleCollageChange(url,"answer_audio",null,currentAnswer?.answer ? currentAnswer?.answer : question.collageFrame, index);
                                            trenacriptAudio(url);
                                        }}
                                        refresh={() => navigate(-1)}
                                        source={currentAnswer?.answer_audio || ""}
                                        setButtonDisabled={setButtonDisabled}
                                        />
                                    )}
                                    </>
                                )}

                                {question.type === 'twoMinAudio' && (
                                    <>
                                        <AudioRecorder
                                           maxTime={question.duration || 120}
                                            handleAudio={url => {
                                                handleSelect(question?.oldIndex, url, 'audio')
                                                trenacriptAudio(url)
                                            }}
                                            refresh={() => navigate(-1)}
                                            source={currentAnswer?.answer || ""}
                                            setButtonDisabled={setButtonDisabled}
                                        />
                                    </>
                                )}
                                {question.type === 'trueFalse' && (
                                    <>
                                        {map(get(question, "options", []), (option, i) => {
                                            if (!option || !option.value) return null;
                                            return (
                                                <Row key={i} style={{ marginBottom: '8px' ,  display: "flex", flexDirection: "row", alignItems: "center"  }}>
                                                     <span style={{ marginRight: '5px' }}>{OPTION_LABEL[i]}</span>
                                                    <Option  selected={selections[question?.oldIndex] && selections[question?.oldIndex]?.answer === `${option?.oldIndex}`} onClick={(e) => {
                                                        e.preventDefault()
                                                        handleSelect(question?.oldIndex, `${option?.oldIndex}`, 'string', selections)
                                                    }}>{handleAddedLabel(option?.value)}</Option>
                                                </Row>
                                            )
                                        })}
                                    </>
                                )}

                                {question.type === 'picture' && (
                                   <StudentPictureAssignment  
                                   states={{question,selections,isTablate}} 
                                   funcObj={{handleImageSelect,setOpenImageViewModal,trenacriptAudio,setButtonDisabled,handleAdditionalImages}}
                                   isNewSubmission={!currentSubmission || (currentSubmission && !currentSubmission.complete && (!currentSubmission.pastSubmissions || currentSubmission.pastSubmissions.length === 0))}
                                   />
                                )}


                            </Content>
                            <div className='nextPrevSlide'>
                                 <Row align="middle" justify="space-between" style={{ marginTop: '16px', gap: 10 }}>
                                {/* Previous Question Button */}
                                <Button
                                    className='prevQuesbtn'
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        handlePreviousQuestion();
                                    }}
                                    disabled={step <= 0 || buttonDisabled}
                                    style={{
                                        ...(forMobile && { height: '36px' })
                                    }}
                                >
                                    <ArrowLeftOutlined style={{ height: '18px', margin: '0px 5px 0px 0px', width: '18px' }} />{forMobile ? "" : "Prev. Question"}
                                </Button>

                                {/* Finish Later / Close Preview Button */}
                                <Button
                                    className='finishQuesbtn'
                                    variant="contained"
                                    color={"secondary"}
                                    onClick={() => {finishlaterClick()}}
                                    type='submit'
                                    id={"finish_later"}
                                    disabled={buttonDisabled}
                                    style={{ cursor: timmer > 0 ? "not-allowed" : "pointer", textTransform: "capitalize", minWidth: 140 }}
                                >
                                    {userRol === 'student' ? 'Finish Later' : 'Close Preview'}
                                </Button>

                                {/* Next Question Button */}
                                <Button
                                    className='prevQuesbtn'
                                    variant="contained"
                                    color="primary"
                                    disabled={disabledCheck(question?.oldIndex) || assignmentCreationLoading || data?.questions.length === index + 1 || completed || buttonDisabled}
                                    style={{ cursor: assignmentCreationLoading ? 'progress' : 'pointer', ...(forMobile && { height: '36px' }) }}
                                    onClick={handleNextQuestion}
                                >
                                   {forMobile ? "" : "Next Question"}
                                    <ArrowForward style={{ height: '18px', margin: '0px 0px 0px 6px', width: '18px' }} />
                                </Button>
                            </Row>

                            {/* Submit Assignment Button */}
                            {data?.questions.length === index + 1 && !completed && (
                                <Row style={{ justifyContent: "center", marginTop: 15, marginBottom: 0 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={disabledCheck(question?.oldIndex) || assignmentCreationLoading || completed || buttonDisabled}
                                        style={{ cursor: assignmentCreationLoading ? "progress" : "pointer" }}
                                        onClick={() => {onSubmitCall(index)}}
                                        type='submit'
                                    >
                                        Submit Assignment
                                        <Done style={{ height: '18px', margin: '0px 0px 0px 6px', width: '18px' }} />
                                    </Button>
                                </Row>
                            )}

                            </div>
                           
                           
                            {/* {timmer > 0 ? <Typography
                                variant='subtitle1'
                                align='center'
                                style={{ color: COLOR.redishpink , fontSize:12, lineHeight:'12px', marginTop: '16px'}}
                            >
                               Timer-based assignments can't be "finished later", it will be submitted automatically for you if you click on it. 
                            </Typography> : null} */}
                          

                        </QuestionContainer>}
                    </RelativeContainer>
                )
            })}
            {completed && (
                <Wrap>
                    <CheckCircle style={{ color: COLOR.green100, fontSize: '80px', marginBottom: '24px' }} />
                    <Success>Assignment Submitted!</Success>
                </Wrap>
            )}
        </Wrapper>
        </SentryWrap>
    );
};




//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    currentClass: state.currentClass,
    currentOrg: state.currentOrg,
    currentUser: state.currentUser,
    interactions: state.interactions
});

export default connect(mapStateToProps, null)(Assignment);
